export default {
  TiposDesconto: [
    { value: 0, text: 'Isento' },
    { value: 1, text: 'Valor fixo até a data informada' },
    { value: 2, text: 'Percentual até a data informada' },
    { value: 3, text: 'Valor por antecipação dia corrido' },
    { value: 5, text: 'Percentual por antecipação dia corrido' }
  ],
  SituacaoSaldoBloqueadoDBSCore: [
    { value: 0, text: 'Pendente' },
    { value: 1, text: 'Processando' },
    { value: 2, text: 'Processado' },
    { value: 3, text: 'Cancelado' },
    { value: 99, text: 'Erro' }
  ],
  SolicitacoesAnaliseOptions: [
    { value: 0, text: 'Todas' },
    { value: 1, text: 'Permitidas' }
  ],
  SituacaoBloqueio: [
    { value: 1, text: 'Pendente' },
    { value: 2, text: 'Executando' },
    { value: 3, text: 'Vigente' },
    { value: 4, text: 'Finalizado' },
    { value: 99, text: 'Erro' }
  ],
  SituacaoBloqueioAutomatico: [
    { value: 1, text: 'Vigente' },
    { value: 2, text: 'Finalizado' }
  ],
  SituacaoAnaliseCadastral: [
    { value: 1, text: 'Pendente' },
    { value: 2, text: 'Aprovada' },
    { value: 3, text: 'Reprovada' },
    { value: 4, text: 'Pendente Consulta' },
    { value: 5, text: 'Cancelada' },
    { value: 6, text: 'Expirada' }
  ],
  SituacaoAprovacaoSolicitacaoMfa: [
    { value: 1, text: 'Pendente' },
    { value: 2, text: 'Negada por fraude' },
    { value: 3, text: 'Aprovado' },
    { value: 4, text: 'Reprovado' },
    { value: 5, text: 'Expirado' },
    { value: 6, text: 'Concluído' },
    { value: 7, text: 'Cancelado' }
  ],
  TiposJuros: [
    { value: 5, text: 'Isento' },
    { value: 6, text: 'Valor (dia útil)' },
    { value: 1, text: 'Valor (dias corridos)' },
    { value: 8, text: 'Percentual ao mês (dias úteis)' },
    { value: 3, text: 'Percentual ao mês (dias corridos)' }
  ],
  TiposMulta: [
    { value: 3, text: 'Isenta' },
    { value: 1, text: 'Valor Fixo' },
    { value: 2, text: 'Percentual' }
  ],
  TipoSacadorAvalista: [
    { value: 0, text: 'Isento' },
    { value: 1, text: 'CPF' },
    { value: 2, text: 'CNPJ' },
    { value: 3, text: 'PIS/PASEP' },
    { value: 9, text: 'Outros' }
  ],
  TiposArquivoCNAB: [
    { value: 1, text: 'CNAB 240' },
    { value: 2, text: 'CNAB 400' }
  ],
  OrigemEventoRemessaCNABArquivoLog: [
    { value: 1, text: 'API FrontEnd' },
    { value: 2, text: 'API Interna' },
    { value: 3, text: 'API Externa' },
    { value: 4, text: 'API CNAB' },
    { value: 5, text: 'Lambda Importação' },
    { value: 6, text: 'Worker Retorno Remessa' },
    { value: 7, text: 'Worker Processamento' },
    { value: 8, text: 'Worker Remessa Processado' },
    { value: 9, text: 'Worker Retorno Diário' }
  ],
  TipoEventoRemessaCNABArquivoLog: [
    { value: 1, text: 'Recebido' },
    { value: 2, text: 'Validado' },
    { value: 3, text: 'Importado' },
    { value: 4, text: 'Retorno Remessa Gerado' },
    { value: 5, text: 'Retorno Remessa Baixado' },
    { value: 6, text: 'Processado' },
    { value: 7, text: 'Retorno Diário Gerado' },
    { value: 8, text: 'Retorno Diário Baixado' }
  ],
  TiposPagamento: [
    { value: 1, text: 'A vista' },
    { value: 2, text: 'Vencimento determinado' },
    { value: 3, text: 'Carnê' }
  ],
  TiposPessoa: [
    { value: 1, text: 'PF' },
    { value: 2, text: 'PJ' }
  ],
  TiposConta: [
    { value: 1, text: 'Corrente' },
    { value: 2, text: 'Poupança' },
    { value: 3, text: 'Pagamento' }
  ],
  TiposSituacao: [
    { value: 1, text: 'Ativado' },
    { value: 2, text: 'Desativado' }
  ],
  FormatoOperacao: [
    { value: 1, text: 'Por Transação' },
    { value: 2, text: 'Por Registro' },
    { value: 3, text: 'Por Cancelamento' },
    { value: 4, text: 'Por Recebimento' },
    { value: 5, text: 'Por Pagamento' },
    { value: 6, text: 'Por Emissão' },
    { value: 7, text: 'Por Envio' },
    { value: 8, text: 'Por Estorno' },
    { value: 9, text: 'Por Protesto' },
    { value: 10, text: 'Por Compra' },
    { value: 11, text: 'Por Devolução' },
    { value: 12, text: 'Por Liquidação' },
    { value: 13, text: 'Por Transferência' },
    { value: 14, text: 'Por Solicitação' },
    { value: 15, text: 'Por Saque' },
    { value: 16, text: 'Por Data' }
  ],
  TiposSituacaoBooleano: [
    { value: true, text: 'Ativado' },
    { value: false, text: 'Desativado' }
  ],
  StatusSituacao: [
    { value: 1, text: 'Ativo' },
    { value: 2, text: 'Inativo' }
  ],
  SituacaoLimiteAdicional: [
    { value: 1, text: 'Ativo' },
    { value: 2, text: 'Inativo' },
    { value: 3, text: 'Pendente' }
  ],
  SituacaoConta: [
    { value: 1, text: 'Ativa' },
    { value: 2, text: 'Inativa' },
    { value: 3, text: 'Fechada' },
    { value: 4, text: 'Cadastrada' }
  ],
  SituacaoOperador: [
    { value: 0, text: 'Cadastrado' },
    { value: 1, text: 'Ativado' },
    { value: 2, text: 'Desativado' },
    { value: 3, text: 'Pendente Restritivo' },
    { value: 4, text: 'Aguardando Análise' },
    { value: 5, text: 'Recusado' }
  ],
  SituacaoOperadorEdit: [
    { value: 1, text: 'Ativado' },
    { value: 2, text: 'Desativado' },
    { value: 3, text: 'Pendente Restritivo' }
  ],
  SituacaoOperadorCMS: [
    { value: 0, text: 'Cadastrado' },
    { value: 1, text: 'Ativado' },
    { value: 2, text: 'Desativado' }
  ],
  TiposEndereco: [
    { value: 1, text: 'Residencial' },
    { value: 2, text: 'Trabalho' }
  ],
  TiposResidencia: [
    { value: 1, text: 'Alugada' },
    { value: 2, text: 'Própria' },
    { value: 3, text: 'Financiada' },
    { value: 4, text: 'Casa funcional' }
  ],
  Sexo: [
    { value: 'M', text: 'Masculino' },
    { value: 'F', text: 'Feminino' }
  ],
  TiposFeriado: [
    { value: 1, text: 'Nacional' },
    { value: 2, text: 'Estadual' },
    { value: 3, text: 'Municipal' }
  ],
  TiposLancamentos: [
    { value: 'C', text: 'Crédito' },
    { value: 'D', text: 'Débito' }
  ],
  TiposTED: [
    { value: 1, text: 'TED-PAG' },
    { value: 2, text: 'TED-STR' }
  ],
  UFS: [
    { value: 'AC', text: 'AC' },
    { value: 'AL', text: 'AL' },
    { value: 'AM', text: 'AM' },
    { value: 'AP', text: 'AP' },
    { value: 'BA', text: 'BA' },
    { value: 'CE', text: 'CE' },
    { value: 'DF', text: 'DF' },
    { value: 'ES', text: 'ES' },
    { value: 'GO', text: 'GO' },
    { value: 'MA', text: 'MA' },
    { value: 'MG', text: 'MG' },
    { value: 'MS', text: 'MS' },
    { value: 'MT', text: 'MT' },
    { value: 'PA', text: 'PA' },
    { value: 'PB', text: 'PB' },
    { value: 'PE', text: 'PE' },
    { value: 'PI', text: 'PI' },
    { value: 'PR', text: 'PR' },
    { value: 'RJ', text: 'RJ' },
    { value: 'RN', text: 'RN' },
    { value: 'RO', text: 'RO' },
    { value: 'RR', text: 'RR' },
    { value: 'RS', text: 'RS' },
    { value: 'SC', text: 'SC' },
    { value: 'SE', text: 'SE' },
    { value: 'SP', text: 'SP' },
    { value: 'TO', text: 'TO' }
  ],
  ModeloCobrancaTaxa: [
    { value: 0, text: 'Desativado' },
    { value: 1, text: 'Parceiro' },
    { value: 2, text: 'Cliente' }
  ],
  TiposTransacao: [
    { value: 1, text: 'Transferência' },
    { value: 4, text: 'Transferência - conta reserva' },
    { value: 2, text: 'TED' },
    { value: 3, text: 'Boleto' },
    { value: 6, text: 'Boleto - concessionária' },
    { value: 5, text: 'PIX' },
    { value: 1006, text: 'Devolucão Pix' }
  ],
  TiposRecebimentoValorDivergente: [
    { value: 1, text: 'Qualquer valor' },
    { value: 2, text: 'Entre o mínimo e o máximo' },
    { value: 3, text: 'Não aceitar pagamento com valor divergente' },
    { value: 4, text: 'Somente valor mínimo' }
  ],
  TipoPerfilOperador: {
    Nenhum: 0,
    Administrador: 1,
    Operador: 1 << 1,
    Consulta: 1 << 2,
    Contabil: 1 << 3,
    Master: 1 << 4,
    Backoffice: 1 << 5,
    Seguranca: 1 << 6,
    Analise: 1 << 7,
    Antifraude: 1 << 8,
    Boletos: 1 << 9
  },
  StatusAprovacaoBackoffice: [
    { value: 0, text: 'Pendente' },
    { value: 1, text: 'Aprovada' },
    { value: 2, text: 'Reprovada' },
    { value: 3, text: 'Falha' },
    { value: 4, text: 'Processando' }
  ],
  MotivoReprovacaoAlcada: [
    { value: 'Dados do pagamento incorretos', text: 'Dados do pagamento incorretos' },
    { value: 'Documentação insuficiente ou inconsistente', text: 'Documentação insuficiente ou inconsistente' },
    { value: 'Pagamento em desacordo com políticas internas', text: 'Pagamento em desacordo com políticas internas' }
  ],
  TipoOperacaoAlcada: [
    { value: 1, text: 'TED' },
    { value: 2, text: 'Transferência' },
    { value: 3, text: 'Pagamento de Boleto' },
    { value: 4, text: 'Pix' }
  ],
  TipoPerfilRetaguarda: {
    Nenhum: 0,
    Consulta: 1,
    Administrador: 1 << 1,
    Subparceiro: 1 << 2
  },
  TipoPerfilCMS: {
    Nenhum: 0,
    Implantacao: 1,
    Comercial: 1 << 1
  },
  Especie: [
    { value: 1, text: 'CH Cheque' },
    { value: 2, text: 'DM Duplicata Mercantil' },
    { value: 3, text: 'DMI Duplicata Mercantil Indicação' },
    { value: 4, text: 'DS Duplicata de Serviço' },
    { value: 5, text: 'DSI Duplicata de Serviço Indicação' },
    { value: 6, text: 'DR Duplicata Rural' },
    { value: 7, text: 'LC Letra de Câmbio' },
    { value: 8, text: 'NCC Nota de Crédito Comercial' },
    { value: 9, text: 'NCE Nota de Crédito Exportação' },
    { value: 10, text: 'NCI Nota de Crédito Industrial' },
    { value: 11, text: 'NCR Nota de Crédito Rural' },
    { value: 12, text: 'NP Nota Promissória' },
    { value: 13, text: 'NPR Nota Promissória Rural' },
    { value: 14, text: 'TM Triplicata Mercantil' },
    { value: 15, text: 'TS Triplicata de Serviço' },
    { value: 16, text: 'NS Nota de Seguro' },
    { value: 17, text: 'RC Recibo' },
    { value: 18, text: 'FAT Bloqueto' },
    { value: 19, text: 'ND Nota de Débito' },
    { value: 20, text: 'AP Apólice de Seguro' },
    { value: 21, text: 'ME Mensalidade Escolar' },
    { value: 22, text: 'PC Parcela de Consórcio' },
    { value: 23, text: 'NF Nota Fiscal' },
    { value: 24, text: 'DD Documento de Dívida' },
    { value: 25, text: 'Cédula de Produto Rural' },
    { value: 26, text: 'Warrant' },
    { value: 27, text: 'Dívida Ativa de Estado' },
    { value: 28, text: 'Dívida Ativa de Município' },
    { value: 29, text: 'Dívida Ativa da União' },
    { value: 30, text: 'Encargos condominiais' },
    { value: 31, text: 'Cartão de Crédito' },
    { value: 32, text: 'Boleto proposta' },
    { value: 99, text: 'Outros' }
  ],
  OrigemPagamento: [
    { value: 2, text: '2 - Auto Atendimento' },
    { value: 13, text: '13 - Telefone' },
    { value: 14, text: '14 - Internet Banking' },
    { value: 73, text: '73 - Arquivo Eletrônico' },
    { value: 74, text: '74 - Guichê Caixa' },
    { value: 75, text: '75 - Correspondente' },
    { value: 99, text: '99 - Indefinido' }
  ],
  CanalPagamento: [
    { value: 1, text: '1 - Agências' },
    { value: 2, text: '2 - Auto Atendimento' },
    { value: 3, text: '3 - Internet' },
    { value: 5, text: '5 - Correspondente Bancário' },
    { value: 6, text: '6 - CallCenter' },
    { value: 7, text: '7 - ArquivoEletronico' },
    { value: 8, text: '8 - DDA' }
  ],
  BoletoModalidade: [
    { value: 1, text: 'Cobrança Simples' },
    { value: 2, text: 'Cobrança Vinculada' },
    { value: 3, text: 'Cobrança Caucionada' },
    { value: 4, text: 'Cobrança Descontada' },
    { value: 5, text: 'Cobrança Vendor' }
  ],
  SituacaoBloqueioConta: [
    { value: 0, text: 'Todas' },
    { value: 1, text: 'Com Bloqueio' },
    { value: 2, text: 'Sem Bloqueio' }
  ],
  SituacaoSaldoConta: [
    { value: 0, text: 'Todos' },
    { value: 1, text: 'Positivo' },
    { value: 2, text: 'Negativo' }
  ],
  BoletoEspecie: [
    { value: 1, text: 'CH Cheque' },
    { value: 2, text: 'DM Duplicata Mercantil' },
    { value: 3, text: 'DMI Duplicata Mercantil Indicação' },
    { value: 4, text: 'DS Duplicata de Serviço' },
    { value: 5, text: 'DSI Duplicata de Serviço Indicação' },
    { value: 6, text: 'DR Duplicata Rural' },
    { value: 7, text: 'LC Letra de Câmbio' },
    { value: 8, text: 'NCC Nota de Crédito Comercial' },
    { value: 9, text: 'NCE Nota de Crédito Exportação' },
    { value: 10, text: 'NCI Nota de Crédito Industrial' },
    { value: 11, text: 'NCR Nota de Crédito Rural' },
    { value: 12, text: 'NP Nota Promissória' },
    { value: 13, text: 'NPR Nota Promissória Rural' },
    { value: 14, text: 'TM Triplicata Mercantil' },
    { value: 15, text: 'TS Triplicata de Serviço' },
    { value: 16, text: 'NS Nota de Seguro' },
    { value: 17, text: 'RC Recibo' },
    { value: 18, text: 'FAT Bloqueto' },
    { value: 19, text: 'ND Nota de Débito' },
    { value: 20, text: 'AP Apólice de Seguro' },
    { value: 21, text: 'ME Mensalidade Escolar' },
    { value: 22, text: 'PC Parcela de Consórcio' },
    { value: 23, text: 'NF Nota Fiscal' },
    { value: 24, text: 'DD Documento de Dívida' },
    { value: 25, text: 'Cédula de Produto Rural' },
    { value: 26, text: 'Warrant' },
    { value: 27, text: 'Dívida Ativa de Estado' },
    { value: 28, text: 'Dívida Ativa de Município' },
    { value: 29, text: 'Dívida Ativa da União' },
    { value: 30, text: 'Encargos condominiais' },
    { value: 31, text: 'Cartão de Crédito' },
    { value: 32, text: 'Boleto proposta' },
    { value: 99, text: 'Outros' }
  ],
  GruposDashboard: [
    { value: 1, text: 'Contas' },
    { value: 2, text: 'Mensageria' },
    { value: 3, text: 'ContaSwap' },
    { value: 4, text: 'Transacoes' },
    { value: 5, text: 'Callback' },
    { value: 6, text: 'RegistroBoleto' },
    { value: 7, text: 'VersoesAtuaisAppFrontend' },
    { value: 8, text: 'Infracao' },
    { value: 9, text: 'Favorecidos' },
    { value: 10, text: 'Handshakes' },
    { value: 11, text: 'PMA' },
    { value: 12, text: 'ContaDock' }
  ],
  SituacaoBoleto: [
    { value: 0, text: 'Todos' },
    { value: 1, text: 'Pendente Registro' },
    { value: 2, text: 'Registrado' },
    { value: 3, text: 'Erro Registro' },
    { value: 4, text: 'Pago' },
    { value: 5, text: 'Baixado Cedente' },
    { value: 6, text: 'Baixado Data Limite Pagto' },
    { value: 7, text: 'Pendente Baixa Cedente' },
    { value: 8, text: 'Pendente Protesto' },
    { value: 9, text: 'Protestado' },
    { value: 10, text: 'Pago Em Cartório' }
  ],
  SituacaoCessao: [
    { value: 0, text: 'Todas' },
    { value: 1, text: 'Aguardando aprovação pelo correntista' },
    { value: 2, text: 'Aguardando aceite pelo novo cedente' },
    { value: 3, text: 'Aceita pelo novo cedente' },
    { value: 4, text: 'Rejeitada pelo novo cedente' },
    { value: 5, text: 'Solicitação cancelada' },
    { value: 6, text: 'Aguardando aprovação de devolução pelo correntista' },
    { value: 7, text: 'Devolvida para o cedente anterior' },
    { value: 8, text: 'Cedida para um novo cedente' },
    { value: 9, text: 'Finalizada com crédito' },
    { value: 10, text: 'Reprovada pelo cedente atual' },
    { value: 11, text: 'Aguardando aprovação de aceite pelo novo cedente' }
  ],
  SituacaoProtesto: [
    { value: 6, text: 'Protestado' },
    { value: 7, text: 'Aguardando Conciliação de Valores' },
    { value: 12, text: 'Protesto Pago' }
  ],
  SituacaoPiloto: [
    { value: null, text: 'Pendente' },
    { value: 0, text: 'Pendente' },
    { value: 1, text: 'Conferido' },
    { value: 2, text: 'Confirmado' },
    { value: 3, text: 'Creditado' },
    { value: 98, text: 'ErroInterno' },
    { value: 99, text: 'Erro' }
  ],
  SituacaoBoletoPagadorEletronico: [
    { value: 1, text: 'A vencer' },
    { value: 2, text: 'Vencido' }
  ],
  SituacaoPagadorEletronico: [
    { value: null, text: 'Sem adesão' },
    { value: 0, text: 'Sem adesão' },
    { value: 1, text: 'Em ativação' },
    { value: 2, text: 'Ativo' },
    { value: 3, text: 'Erro ativação' },
    { value: 4, text: 'Em exclusão' },
    { value: 5, text: 'Excluído' },
    { value: 6, text: 'Erro exclusão' }
  ],
  SituacaoTransacao: [
    { value: 0, text: '0 - Pendente' },
    { value: 1, text: '1 - Registrando' },
    { value: 2, text: '2 - Registrado' },
    { value: 3, text: '3 - Cancelado' },
    { value: 4, text: '4 - Confirmado' },
    { value: 50, text: '50 - Pendente Reprocessamento' },
    { value: 97, text: '97 - Não Processada' },
    { value: 98, text: '98 - Erro de Negocio' },
    { value: 99, text: '99 - Erro de Sistema' }
  ],
  OrigemTransacao: [
    { value: '', text: 'Todos' },
    { value: 0, text: 'Outros Movtos' },
    { value: 1, text: 'Transf. Entre Contas' },
    { value: 2, text: 'TED Enviada' },
    { value: 3, text: 'Pagamento Boleto' },
    { value: 4, text: 'Transf. Entre CR.' },
    { value: 5, text: 'PIX Enviado' },
    { value: 6, text: 'Pagamento Titulo Concessionaria' },
    { value: 7, text: 'Compra Cartao' },
    { value: 8, text: 'Saque Cartao' },
    { value: 9, text: 'SolicitacaoCartao' },
    { value: 10, text: 'CobrancaRecorrente' },
    { value: 501, text: 'Transf. Entre Contas' },
    { value: 502, text: 'TED Recebida' },
    { value: 503, text: 'Boleto Recebido' },
    { value: 504, text: 'Transf. CR.' },
    { value: 505, text: 'PIX Recebido' },
    { value: 506, text: 'SLC Recebido' },
    { value: 507, text: 'Crédito Unificado Boleto Recebido' },
    { value: 1001, text: 'Dev. Transf.' },
    { value: 1002, text: 'TED Devolvida' },
    { value: 1003, text: 'Dev. Boleto' },
    { value: 1004, text: 'Dev. Transf. CR.' },
    { value: 1005, text: 'PIX Estornado' },
    { value: 1006, text: 'PIX Devolvido' },
    { value: 1007, text: 'Dev. Pagamento Titulo Concessionaria' },
    { value: 1501, text: 'Registro Boleto' },
    { value: 1502, text: 'Alteracao Boleto' },
    { value: 1503, text: 'Cancelamento Boleto' },
    { value: 1701, text: 'Cessão Boleto' },
    { value: 2001, text: 'Arq. CNAB Registro' },
    { value: 2002, text: 'Arq. CNAB Pagamento Boletos' },
    { value: 2003, text: 'Arq. CNAB Alteração Boletos' },
    { value: 2004, text: 'Arq. CNAB Cancelamento Boletos' },
    { value: 2501, text: 'Split' },
    { value: 3001, text: 'Serviço' },
    { value: 3002, text: 'Bloqueio Serviço' },
    { value: 4001, text: 'Safe' },
    { value: 4501, text: 'Prévia Boleto Crédito' },
    { value: 5001, text: 'Rejeição PIX Enviado' },
    { value: 5004, text: 'Rejeição Devolução PIX ' }
  ],
  OrigemTransacaoTransferenciaCedente: [
    { value: 2005, text: 'Arq. CNAB Troca de cedente' }
  ],
  MetodoHttp: [
    { value: null, text: 'Selecione' },
    { value: 0, text: 'GET' },
    { value: 1, text: 'POST' },
    { value: 2, text: 'PUT' },
    { value: 3, text: 'DELETE' },
    { value: 4, text: 'HEAD' },
    { value: 5, text: 'OPTIONS' },
    { value: 6, text: 'PATCH' },
    { value: 7, text: 'MERGE' },
    { value: 8, text: 'COPY' }
  ],
  OrigemNossoNumero: [
    { value: 1, text: 'BMP' },
    { value: 2, text: 'Cliente' }
  ],
  EstadoCivil: [
    { value: 1, text: 'Solteiro(a)' },
    { value: 2, text: 'Casado(a)' },
    { value: 3, text: 'Desquitado(a)' },
    { value: 4, text: 'Divorciado(a)' },
    { value: 5, text: 'Separado(a)' },
    { value: 6, text: 'Viúvo(a)' },
    { value: 7, text: 'Outros' },
    { value: 8, text: 'Não Informado' },
    { value: 9, text: 'Vinculo Conjugal' }
  ],
  TiposSplit: [
    { value: 1, text: 'Percentual' },
    { value: 2, text: 'Valor' }
  ],
  TiposLimite: [
    { value: 1, text: 'Valor' },
    { value: 2, text: 'Percentual' }
  ],
  TiposTransacaoLimites: [
    { value: 1, text: 'Saque' },
    { value: 2, text: 'Gastos' },
    { value: 3, text: 'TED' },
    { value: 4, text: 'Transferência' },
    { value: 5, text: 'Pagamento Boleto' }
  ],
  TiposTransacaoLimiteAdicional: [
    { value: 1, text: 'Saque' },
    { value: 2, text: 'Gastos' },
    { value: 3, text: 'TED' },
    { value: 4, text: 'Transferência' },
    { value: 5, text: 'Pagamento Boleto' },
    { value: 6, text: 'Pix' },
    { value: 8, text: 'Pix Automático' }
  ],
  TiposRetornoCNAB240: [
    { value: 0, text: 'Remessa' },
    { value: 1, text: 'Diário' }
  ],
  TiposTransacaoLimiteOperador: [
    { value: 3, text: 'TED' },
    { value: 4, text: 'Transferência' },
    { value: 5, text: 'Pagamento Boleto' },
    { value: 6, text: 'Pix' }
  ],
  IndicadorBoleano: [
    { value: null, text: 'Não' },
    { value: 1, text: 'Sim' }
  ],
  IndicadorPEP: [
    { value: 1, text: 'Sim' },
    { value: 2, text: 'Não' }
  ],
  ResponsabilidadeSocio: [
    { value: 1, text: 'Sócio' },
    { value: 2, text: 'Diretor' },
    { value: 3, text: 'Procurador' },
    { value: 4, text: 'Gerente' },
    { value: 5, text: 'Coordenador' }
  ],
  TipoAssinaturaSocio: [
    { value: 1, text: 'Assina isoladamente' },
    { value: 2, text: 'Assina em conjunto' },
    { value: 3, text: 'Não Assina' }
  ],
  TipoRegistro: [
    { value: 1, text: 'Online' },
    { value: 2, text: 'Offline' },
    { value: 3, text: 'CNAB' }
  ],
  TipoOperacao: [
    { value: 1, text: 'Movimento' },
    { value: 2, text: 'Tarifário' },
    { value: 3, text: 'Split' },
    { value: 4, text: 'Transitória' }
  ],
  TipoRecebTED: [
    { value: 1, text: 'Somente Correntista Principal' },
    { value: 2, text: 'Todos Correntistas' }
  ],
  CodMoeda: [
    { value: 1, text: 'Reservado para uso futuro' },
    { value: 2, text: 'Dólar Americano Comercial (Venda)' },
    { value: 3, text: 'Dólar Americano Turismo (Venda)' },
    { value: 4, text: 'ITRD' },
    { value: 5, text: 'IDTR' },
    { value: 6, text: 'UFIR Diária' },
    { value: 7, text: 'UFIR Mensal' },
    { value: 8, text: 'FAJ-TR' },
    { value: 9, text: 'Real' },
    { value: 10, text: 'TR' },
    { value: 11, text: 'IGPM' },
    { value: 12, text: 'CDI' },
    { value: 13, text: 'Percentual do CDI' },
    { value: 14, text: 'Euro' },
    { value: 15, text: 'CDI-CETIP' },
    { value: 16, text: 'CHF' },
    { value: 17, text: 'CUB/RS(NOVO)' },
    { value: 18, text: 'CUB/RS(R8-N)' },
    { value: 19, text: 'CUB/SC (ANTIGO)' },
    { value: 20, text: 'CUBRS' },
    { value: 21, text: 'CUB-SC (NOVO)' },
    { value: 22, text: 'GBP' },
    { value: 23, text: 'ICC (SALVADOR)' },
    { value: 24, text: 'IGPM (A)' },
    { value: 25, text: 'IGPM (N)' },
    { value: 26, text: 'INCC' },
    { value: 27, text: 'INCC-M' },
    { value: 28, text: 'INPC' },
    { value: 29, text: 'JPY' },
    { value: 30, text: 'TJLP' }
  ],
  SituacaoTituloPgto: [
    { value: 1, text: 'Boleto já baixado' },
    { value: 2, text: 'Boleto bloqueado para pagamento' },
    {
      value: 3,
      text: 'Boleto encontrado na base centralizada e Cliente Beneficiário inapto na Instituição emissora do título'
    },
    {
      value: 4,
      text: 'Boleto encontrado na base e cliente Beneficiário sem cadastro'
    },
    {
      value: 5,
      text: 'Boleto encontrado na base centralizada e Cliente Beneficiário em análise na Instituição emissora do título'
    },
    { value: 6, text: 'Boleto excedeu o limite de pagamentos parciais' },
    { value: 7, text: 'Baixa operacional integral já registrada' },
    {
      value: 9,
      text: 'Boleto excedeu o valor de saldo para pagamento parcial para o tipo de modelo de cálculo 04'
    },
    {
      value: 10,
      text: 'Boleto encontrado na base centralizada e Cliente Beneficiário inapto em Instituição diferente da emissora'
    },
    {
      value: 11,
      text: 'Boleto encontrado na base centralizada e Cliente Beneficiário em análise em Instituição diferente da emissora'
    },
    {
      value: 12,
      text: 'Boleto encontrado na base centralizada e Cliente Beneficiário apto'
    }
  ],
  TipoConfirmacao: [
    { value: 0, text: 'Recusa' },
    { value: 1, text: 'Aprovação' }
  ],
  SituacaoArquivoMultiContas: [
    { value: 0, text: 'Em Validação' },
    { value: 1, text: 'Arquivo com inconsistências' },
    { value: 2, text: 'Pendente aprovação' },
    { value: 3, text: 'Processado com sucesso' },
    { value: 4, text: 'Processado com erro' },
    { value: 5, text: 'Recusado' },
    { value: 6, text: 'Aguardando Processamento' }
  ],
  TipoChavePix: [
    { value: -1, text: 'CPF' },
    { value: 0, text: 'CPF' },
    { value: 1, text: 'CNPJ' },
    { value: 2, text: 'Telefone' },
    { value: 3, text: 'Email' },
    { value: 4, text: 'EVP' }
  ],
  TipoChavePixFavorecido: [
    { value: 0, text: 'CPF' },
    { value: 1, text: 'CNPJ' },
    { value: 2, text: 'Telefone' },
    { value: 3, text: 'Email' },
    { value: 4, text: 'EVP' }
  ],
  SituacaoChavePix: [
    { value: 1, text: 'Registrando' },
    { value: 2, text: 'Registrada' },
    { value: 3, text: 'Portada' },
    { value: 4, text: 'Portando' },
    { value: 5, text: 'Removida' },
    { value: 6, text: 'Removendo' },
    { value: 7, text: 'Erroregistro' },
    { value: 8, text: 'Atualizando' }
  ],
  PeriodoFiltro: [
    { value: 1, text: 'Mês Atual' },
    { value: 2, text: 'Mês Passado' },
    { value: 3, text: 'Mês Retrasado' },
    { value: 4, text: 'Período Customizado' }
  ],
  PeriodoFiltroFuturo: [
    { value: 1, text: 'Mês Atual' },
    { value: 2, text: 'Período Customizado' }
  ],
  MotivosDevolucao: [
    { value: 0, text: 'Ordem de pagamento em duplicidade' },
    {
      value: 1,
      text: 'Devolução devido ao valor recebido não estar de acordo com o esperado'
    },
    { value: 2, text: 'Devolução fundada por suspeita de fraude' },
    {
      value: 3,
      text: 'Devolução de pagamento solicitada pelo usuário recebedor motivada por um erro na transação'
    },
    {
      value: 4,
      text: 'Devolução após solicitação de cancelamento da transação'
    },
    { value: 5, text: 'Falha operacional do PSP do pagador' },
    {
      value: 6,
      text: 'Devolução solicitado pelo usuário recebedor do pagamento original'
    },
    { value: 11, text: 'Ordem de pagamento não justificada' }
  ],
  MotivosDevolucaoSelecionar: [
    { value: 2, text: 'Devolução fundada por suspeita de fraude' },
    {
      value: 3,
      text: 'Devolução de pagamento solicitada pelo usuário recebedor motivada por um erro na transação'
    },
    { value: 5, text: 'Falha operacional do PSP do pagador' },
    {
      value: 6,
      text: 'Devolução solicitado pelo usuário recebedor do pagamento original'
    }
  ],
  SituacaoContabil: [
    { value: 1, text: 'Ativa' },
    { value: 2, text: 'Inativa' }
  ],
  TipoBuscaOperacao: [
    { value: 1, text: 'Movimento' },
    { value: 2, text: 'Tarifario' },
    { value: 3, text: 'Transitoria' },
    { value: 4, text: 'Split' }
  ],
  Escolaridade: [
    { value: 1, text: 'Cursando Educação Infantil' },
    { value: 2, text: 'Educação Infantil Completa' },
    { value: 3, text: 'Cursando Ensino Fundamental' },
    { value: 4, text: 'Ensino Fundamental Completo' },
    { value: 5, text: 'Cursando Ensino Médio' },
    { value: 6, text: 'Ensino Médio Completo' },
    { value: 7, text: 'Cursando Ensino Superior' },
    { value: 8, text: 'Ensino Superior Completo' },
    { value: 9, text: 'Cursando Especialização' },
    { value: 10, text: 'Especialização Completa' },
    { value: 11, text: 'Cursando Mestrado' },
    { value: 12, text: 'Mestrado Completo' },
    { value: 13, text: 'Cursando Doutorado' },
    { value: 14, text: 'Doutorado Completo' },
    { value: 15, text: 'Cursando Pos Doutorado' },
    { value: 16, text: 'Pos Doutorado Completo' },
    { value: 17, text: 'Analfabeto' },
    { value: 18, text: 'Sem instrução escolar' }
  ],
  TipoPerfilFrontEnd: [
    { value: 1, text: 'Correntista' },
    { value: 2, text: 'Movimentação' },
    { value: 3, text: 'Consulta' }
  ],
  SituacaoTransferencia: [
    { value: 1, text: 'Sucesso' },
    { value: 2, text: 'Erro' }
  ],
  TipoTransacaoSwap: [
    { value: 1, text: 'Transferência da PMA para Treasury' },
    { value: 2, text: 'Transferência da Treasury para PMA' },
    { value: 3, text: 'Transferência da Treasury para BAG' },
    { value: 4, text: 'Transferência da BAG para Treasury' }
  ],
  PermissaoSolicitacaoCartao: [
    { value: 1, text: 'Total' },
    { value: 2, text: 'Individual' },
    { value: 3, text: 'Nenhuma' }
  ],
  TipoEnvioRelatorioPix: [
    { value: 1, text: 'Novas Informações' },
    { value: 2, text: 'Alteração de informações já enviadas' }
  ],
  VolumetriaFila: [
    { value: '0', text: 'Todas' },
    { value: '1', text: 'EnvioSpi' },
    { value: '2', text: 'EnvioSpb' },
    { value: '3', text: 'EnvioNpc' },
    { value: '4', text: 'RetornoSpi' },
    { value: '5', text: 'RetornoSpb' },
    { value: '6', text: 'RetornoNpc' }
  ],
  QueueEnvioCodMsg: [
    { value: 'Todas', text: 'Todas' },
    { value: 'DDA0101', text: 'DDA0101' },
    { value: 'DDA0102', text: 'DDA0102' },
    { value: 'DDA0108', text: 'DDA0108' },
    { value: 'DDA0110', text: 'DDA0110' },
    { value: 'DDA0118', text: 'DDA0118' },
    { value: 'DDA0501', text: 'DDA0501' },
    { value: 'LPI0001', text: 'LPI0001' },
    { value: 'LPI0003', text: 'LPI0003' },
    { value: 'PAG0108', text: 'PAG0108' },
    { value: 'PAG0111', text: 'PAG0111' },
    { value: 'STR0007', text: 'STR0007' },
    { value: 'STR0008', text: 'STR0008' },
    { value: 'STR0010', text: 'STR0010' },
    { value: 'STR0013', text: 'STR0013' },
    { value: 'STR0026', text: 'STR0026' },
    { value: 'SLC0001', text: 'SLC0001' },
    { value: 'SLC0005', text: 'SLC0005' }
  ],
  QueueEnvioPixCodMsg: [
    { value: 'Todas', text: 'Todas' },
    { value: 'CAMT060', text: 'CAMT060' },
    { value: 'PACS002', text: 'PACS002' },
    { value: 'PACS004', text: 'PACS004' },
    { value: 'PACS008', text: 'PACS008' }
  ],
  QueueRetornoCodMsg: [
    { value: 'Todas', text: 'Todas' },
    { value: 'ADDA101RET', text: 'ADDA101RET' },
    { value: 'ADDA108R2', text: 'ADDA108R2' },
    { value: 'ADDA120', text: 'ADDA120' },
    { value: 'DDA0101E', text: 'DDA0101E' },
    { value: 'DDA0101R1', text: 'DDA0101R1' },
    { value: 'DDA0102E', text: 'DDA0102E' },
    { value: 'DDA0102R1', text: 'DDA0102R1' },
    { value: 'DDA0108E', text: 'DDA0108E' },
    { value: 'DDA0108R1', text: 'DDA0108R1' },
    { value: 'DDA0108R2', text: 'DDA0108R2' },
    { value: 'DDA0110E', text: 'DDA0110E' },
    { value: 'DDA0110R1', text: 'DDA0110R1' },
    { value: 'DDA0115R2', text: 'DDA0115R2' },
    { value: 'DDA0118E', text: 'DDA0118E' },
    { value: 'DDA0118R1', text: 'DDA0118R1' },
    { value: 'DDA0400', text: 'DDA0400' },
    { value: 'DDA0403', text: 'DDA0403' },
    { value: 'DDA0404', text: 'DDA0404' },
    { value: 'DDA0501E', text: 'DDA0501E' },
    { value: 'DDA0501R1', text: 'DDA0501R1' },
    { value: 'DDA0506', text: 'DDA0506' },
    { value: 'GEN0004', text: 'GEN0004' },
    { value: 'LDL0020R2', text: 'LDL0020R2' },
    { value: 'LPI0001R1', text: 'LPI0001R1' },
    { value: 'LPI0003R1', text: 'LPI0003R1' },
    { value: 'LTR0001', text: 'LTR0001' },
    { value: 'LTR0005R2', text: 'LTR0005R2' },
    { value: 'LTR0006R2', text: 'LTR0006R2' },
    { value: 'PAG0107R2', text: 'PAG0107R2' },
    { value: 'PAG0108E', text: 'PAG0108E' },
    { value: 'PAG0108R1', text: 'PAG0108R1' },
    { value: 'PAG0108R2', text: 'PAG0108R2' },
    { value: 'PAG0111E', text: 'PAG0111E' },
    { value: 'PAG0111R1', text: 'PAG0111R1' },
    { value: 'PAG0111R2', text: 'PAG0111R2' },
    { value: 'PAG0143R2', text: 'PAG0143R2' },
    { value: 'STR0004R2', text: 'STR0004R2' },
    { value: 'STR0006R2', text: 'STR0006R2' },
    { value: 'STR0007E', text: 'STR0007E' },
    { value: 'STR0007R1', text: 'STR0007R1' },
    { value: 'STR0007R2', text: 'STR0007R2' },
    { value: 'STR0008E', text: 'STR0008E' },
    { value: 'STR0008R1', text: 'STR0008R1' },
    { value: 'STR0008R2', text: 'STR0008R2' },
    { value: 'STR0010E', text: 'STR0010E' },
    { value: 'STR0010R1', text: 'STR0010R1' },
    { value: 'STR0010R2', text: 'STR0010R2' },
    { value: 'STR0013R1', text: 'STR0013R1' },
    { value: 'STR0015', text: 'STR0015' },
    { value: 'STR0016', text: 'STR0016' },
    { value: 'STR0017', text: 'STR0017' },
    { value: 'STR0018', text: 'STR0018' },
    { value: 'STR0019', text: 'STR0019' },
    { value: 'STR0025R2', text: 'STR0025R2' },
    { value: 'STR0026R1', text: 'STR0026R1' },
    { value: 'STR0026R2', text: 'STR0026R2' },
    { value: 'STR0051R2', text: 'STR0051R2' },
    { value: 'SLC0001', text: 'SLC0001' },
    { value: 'SLC0005', text: 'SLC0005' }
  ],
  QueueRetornoPixCodMsg: [
    { value: 'Todas', text: 'Todas' },
    { value: 'ADMI002', text: 'ADMI002' },
    { value: 'CAMT052', text: 'CAMT052' },
    { value: 'CAMT053', text: 'CAMT053' },
    { value: 'CAMT054', text: 'CAMT054' },
    { value: 'PACS002', text: 'PACS002' },
    { value: 'PACS004', text: 'PACS004' },
    { value: 'PACS008', text: 'PACS008' },
    { value: 'PIBR002', text: 'PIBR002' },
    { value: 'REDA016', text: 'REDA016' },
    { value: 'REDA041', text: 'REDA041' }
  ],
  SituacaoAgendamento: [
    { value: 'Todas', text: 'Todas' },
    { value: 32, text: 'Agendado' },
    { value: 42, text: 'Executado' },
    { value: 34, text: 'Cancelado' },
    { value: 50, text: 'Reprocessar' }
  ],
  OperacaoConsulta: [
    { value: 1, text: 'Transferência Interna' },
    { value: 2, text: 'Envio TED' },
    { value: 3, text: 'Pagamento de Boleto' },
    { value: 5, text: 'Pix' },
    { value: 1006, text: 'Devolução PIX' }
  ],
  SituacaoAprovacoes: [
    { value: 'Todas', text: 'Todas' },
    { value: 0, text: 'Pendente' },
    { value: 1, text: 'Aprovado' },
    { value: 2, text: 'Reprovado' },
    { value: 3, text: 'Cancelado' }
  ],
  SituacaoAprovadoAnaliseCadastro: [
    { value: false, text: 'Reprovado' },
    { value: true, text: 'Aprovado' }
  ],
  SituacaoSolicitacaoEncerramentoConta: [
    { value: 1, text: 'Pendente' },
    { value: 2, text: 'Confirmada' },
    { value: 3, text: 'Rejeitada' },
    { value: 4, text: 'Cancelada' },
    { value: 5, text: 'Impedido' }
  ],
  SituacaoCadastroRestritivo: [
    { value: 1, text: 'Ativado' },
    { value: 2, text: 'Desativado' },
    { value: 3, text: 'Pendente Regularização' }
  ],
  IndicadorPermissaoRecebimento: [
    { value: null, text: 'Padrão (Sim)' },
    { value: true, text: 'Sim' },
    { value: false, text: 'Não' }
  ],
  SituacaoRetornoCNABArquivo: [
    { value: 0, text: 'Pendente' },
    { value: 1, text: 'Gerado' },
    { value: 99, text: 'Erro Sistema' }
  ],
  SituacaoRemessaCNABArquivo: [
    { value: 0, text: 'Pendente de Importação' },
    { value: 1, text: 'Importando' },
    { value: 2, text: 'Importado' },
    { value: 3, text: 'Processado' },
    { value: 97, text: 'Não Processado' },
    { value: 98, text: 'Erro Negócio' },
    { value: 99, text: 'Erro Sistema' }
  ],
  TipoPermissaoAnaliseCadastro: [
    { value: 0, text: 'Nenhum' },
    { value: 1, text: 'Criação' },
    { value: 2, text: 'Edição' },
    { value: 4, text: 'Vínculo' }
  ],
  OperacoesAnaliseCadastro: [
    { value: 1, text: 'Criação' },
    { value: 2, text: 'Edição' },
    { value: 4, text: 'Vínculo' }
  ],
  TipoBooleano: [
    { value: null, text: 'Não' },
    { value: 0, text: 'Não' },
    { value: 1, text: 'Sim' },
    { value: 2, text: 'Não' },
    { value: true, text: 'Sim' },
    { value: false, text: 'Não' }
  ],
  TipoLogCadastroRestritivo: [
    { value: 1, text: 'Cadastral' },
    { value: 2, text: 'Movimento Financeiro' }
  ],
  MotivoRestricao: [
    { value: 1, text: 'Prevenção a fraude' },
    { value: 2, text: 'Comitê Compliance' },
    { value: 3, text: 'Determinação judicial' },
    { value: 4, text: 'Decisão comercial' },
    { value: 5, text: 'Carta de repatriação de valores outros Bancos' },
    { value: 6, text: 'Recebimento de boletim de ocorrência' },
    { value: 7, text: 'Outros' }
  ],
  MotivoEncerramento: [
    { value: 1, text: 'Encerramento por desinteresse comercial' },
    { value: 2, text: 'Encerramento a pedido do titular da conta' },
    { value: 3, text: 'Encerramento prevenção a fraude' },
    { value: 4, text: 'Encerramento solicitado pelo Comitê Compliance' },
    { value: 5, text: 'Encerramento por decisão judicial' },
    { value: 6, text: 'Encerramento por cancelamento de operação' },
    { value: 7, text: 'Encerramento por cobrança de tarifa' },
    {
      value: 8,
      text: 'Encerramento por não reconhecimento de conta pagamento'
    },
    { value: 9, text: 'Encerramento por falta de atendimento' },
    { value: 11, text: 'Encerramento a pedido do parceiro' },
    { value: 10, text: 'Outros' }
  ],
  TipoTemplateEmail: [
    { value: 1, text: 'Sem saldo conta SWAP' },
    { value: 2, text: 'Sem saldo SWAP para o correntista' },
    { value: 4, text: 'Transação Agendada' },
    { value: 5, text: 'Transação Agendada Concluída' },
    { value: 6, text: 'Transação Agendada Não Concluída' },
    { value: 7, text: 'Transação Agendada D-1' },
    { value: 8, text: 'Transação Agendada Pendente' },
    { value: 9, text: 'Transação Concluída' },
    { value: 10, text: 'Transação Não Concluída' },
    { value: 11, text: 'Solicitação de Limite' },
    { value: 12, text: 'Aprovação de Limite' },
    { value: 13, text: 'Reprovação de Limite' },
    { value: 14, text: 'Solicitação Cadastral Expirada' },
    { value: 21, text: 'Relatório Extração Contábil' },
    { value: 22, text: 'Emissão de relatório - Concluída' },
    {
      value: 23,
      text: 'Atualização: reporte regulatório APIX1201 gerado com sucesso'
    },
    {
      value: 24,
      text: 'Erro: houve um problema ao gerar o reporte regulatório APIX1201'
    },
    { value: 31, text: 'Bloqueio de cartão' },
    { value: 32, text: 'Desbloqueio de cartão' },
    { value: 33, text: 'Análise Solicitação Cartão' },
    { value: 34, text: 'Análise Solicitação Cartão - Interno' },
    {
      value: 35,
      text: 'Informativo de inconsistências na solicitação do cartão'
    },
    {
      value: 36,
      text: 'Erro/Inconsistência - Solicitação do cartão - Interno'
    },
    { value: 41, text: 'Portabilidade/Reivindicação Expirada - Interno' },
    { value: 42, text: 'Portabilidade/Reivindicação Expirada - Cliente' },
    { value: 43, text: 'Portabilidade/Reivindicação Pix Cliente - Aceita' },
    {
      value: 44,
      text: 'Portabilidade/Reivindicação Pix Cliente - Solicitação Externa'
    },
    { value: 45, text: 'Solicitação de Portabilidade Pendente - Interno' },
    { value: 51, text: 'Portabilidade/Reivindicação Código MFA' },
    { value: 52, text: 'Solicitação de cadastro de MFA aceita' },
    { value: 53, text: 'Solicitação de cadastro de MFA suspeita' },
    { value: 54, text: 'Solicitação de cadastro de MFA expirou' },
    { value: 55, text: 'Retorno diário Lambda Solicitações MFA' },
    { value: 56, text: 'Atualização - Cadastro MFA' },
    { value: 61, text: 'Encerramento de conta para Operador' },
    { value: 71, text: 'Erro Registro CNAB' },
    { value: 81, text: 'Encerramento de Conta Pendente' },
    { value: 82, text: 'Primeiro Acesso' },
    { value: 83, text: 'Primeiro Acesso Frontend' },
    { value: 85, text: 'Recuperar senha' },
    { value: 86, text: 'Recuperar senha Frontend' },
    { value: 87, text: 'Encerramento de conta' },
    { value: 88, text: 'Código de Verificação' },
    { value: 89, text: 'Solicitação Pendente - Devolução PIX' },
    { value: 90, text: 'Aprovação Pendente' },
    { value: 91, text: 'Aprovação concluído' },
    { value: 92, text: 'Aprovação Do Dia Anterior Pendente' },
    { value: 93, text: 'MFA Alteração Suspeita' },
    { value: 94, text: 'MFA Alteração Suspeita Parceiro' },
    { value: 99, text: 'Crédito Operacional não concluído' },
    { value: 101, text: 'Crédito Suspeito' },
    { value: 105, text: 'Solicitação Concluída - Favorecido Cadastrado' },
    {
      value: 106,
      text: 'Solicitação Concluída - Favorecido Cadastrado - Prioritário'
    },
    {
      value: 107,
      text: 'Solicitação Não Concluída - Favorecido não cadastrado'
    },
    { value: 110, text: 'Reset Limite Adicional' },
    { value: 111, text: 'Reset Limite Adicional Operador' },
    { value: 112, text: 'Cadastro Restritivo - Operador bloqueado' },
    { value: 117, text: 'Cancelamento da solicitação de senha eletrônica' },
    { value: 118, text: 'Bloqueio da senha eletrônica' },
    { value: 123, text: 'Reconsulta bureau sem retorno' },
    { value: 124, text: 'Solicitação Cadastral Aprovada' },
    { value: 125, text: 'Solicitação Cadastral Rejeitada' },
    { value: 126, text: 'Solicitação Cadastral Em Análise' },
    { value: 127, text: 'Solicitação Cadastral Pendente' },
    {
      value: 128,
      text: 'Solicitação Alteração Operador FrontEnd ou Correntista'
    },
    { value: 129, text: 'Reconsulta bureau' },
    { value: 125, text: 'Solicitacao Cadastral Negada' },
    { value: 130, text: 'Aprovação Limite - Pendente' },
    {
      value: 131,
      text: 'Confirmação de Alteração de Senha - Operador Backoffice'
    },
    {
      value: 132,
      text: 'Confirmação de Alteração de Senha - Operador Retaguarda'
    },
    {
      value: 133,
      text: 'Confirmação de Alteração de Senha - Operador Front-end'
    },
    {
      value: 134,
      text: 'Confirmação Cadastramento de Token  - Operador Retaguarda'
    },
    {
      value: 135,
      text: 'Confirmação Cadastramento de Token - Operador Frontend'
    },
    {
      value: 136,
      text: 'Confirmação de Alteração de Senha - Operador Onboarding'
    },
    { value: 140, text: 'Importação Arquivo Limite Operação - Inicio' },
    { value: 141, text: 'Importação Arquivo Limite Operação - Finalizado' },
    { value: 142, text: 'Pagamento Boleto Concessionária' },
    { value: 143, text: 'Devolução Pagamento Boleto Concessionária' },
    { value: 144, text: 'Devolução PIX ' },
    { value: 145, text: 'Compartilhamento QR Code - Dinâmico' },
    { value: 150, text: 'Possível Fraude Cadastral Detectada' },
    { value: 160, text: 'Chave de Segurança Desabilitada' },
    { value: 171, text: 'Notificação Transferência de Cedente' },
    { value: 172, text: 'Recebimento de Transferência de Cedente' },
    { value: 173, text: 'Transferência de Cedente - Alteração' },
    { value: 180, text: 'Transação Agendada PIX' },
    { value: 181, text: 'Falha na Transação Agendada PIX' },
    { value: 190, text: 'Falha no Registro de Boleto Recorrente' },
    { value: 201, text: 'Boleto Enviado para Protesto' },
    { value: 202, text: 'Boleto Confirmado para Protesto' },
    { value: 203, text: 'Solicitação de Alteração de Boleto' },
    { value: 204, text: 'Liquidação de Protesto de Boleto' },
    { value: 205, text: 'Erro de Envio de Protesto de Boleto' },
    { value: 206, text: 'Erro de Solicitacao de Alteracao de Boleto' },
    { value: 207, text: 'Link Arquivo Diário ACCS001' },
    { value: 208, text: 'Resultado Análise Arquivo' },
    { value: 210, text: 'Cadastro Split' },
    { value: 211, text: 'Boleto a Vencer' },
    { value: 212, text: 'Boleto no dia de Vencimento' },
    { value: 213, text: 'Boleto Vencido' },
    { value: 220, text: 'Relatório Webjud' },
    { value: 250, text: 'Conta ativada - Operador COM biometria' },
    { value: 251, text: 'Conta ativada - Operador SEM biometria' },
    { value: 252, text: 'Conta ativada - Sócio e representante legal' },
    { value: 253, text: 'Conta ativada - Operador com acesso ao app' },
    { value: 254, text: 'Primeiro Acesso - Operador Onboarding Externo' },
    { value: 255, text: 'Pendência de aprovação de conta' },
    { value: 256, text: 'Transacao Multi Contas Arquivo Invalido' },
    { value: 257, text: 'Transacao Multi Contas Arquivo Recusado' },
    { value: 258, text: 'Transacao Multi Contas Arquivo Pendente Analise' },
    { value: 259, text: 'Transacao Multi Contas Arquivo Processado' },
    {
      value: 262,
      text: 'Solicitação de operador em análise - Validação biométrica'
    },
    { value: 300, text: 'Monitor Callback' },
    { value: 998, text: 'Monitor de Serviços' },
    { value: 999, text: 'Outros' },
    { value: 260, text: 'Conta recusada' },
    { value: 261, text: 'Solicitação de abertura de conta cancelada' },
    { value: 292, text: 'Solicitação  Alteração de Limite Recebida IB' },
    { value: 290, text: 'Limite alterado IB' },
    { value: 291, text: 'Limite não alterado IB' },
    { value: 292, text: 'Solicitação limite Temporário IB' },
    { value: 293, text: 'Solicitação Alteração de Limite Recebida IB' },
    { value: 295, text: 'Solicitação Limite IB' },
    { value: 271, text: 'Solicitação Cartão IB' },
    { value: 301, text: 'Cartão Cancelado IB' },
    { value: 302, text: 'Solicitar Bloqueio de Cartão IB' },
    { value: 303, text: 'Solicitar Desbloqueio de Cartão IB' },
    { value: 304, text: 'Falha na ativação do cartão IB' },
    { value: 273, text: 'Cartão ativado IB' },
    { value: 1000, text: 'Atenção Aprovações Pendentes' },
    { value: 1001, text: 'Aprovação Realizada Nome do Lançador IB 2A' },
    { value: 1002, text: 'Aprovação Realizada Nome do Aprovador IB A3' },
    { value: 1003, text: 'Aprovação Concluída Nome Aprovador' },
    { value: 1004, text: 'Aprovação Concluída Nome Lançador' },
    { value: 1005, text: 'Tipo Aprovação Reprovado Nome Aprovador' },
    { value: 1006, text: 'Tipo Aprovação Reprovado Nome Lançador' },
    { value: 1007, text: 'Atenção Tipo Aprovação Modificada' },
    { value: 1008, text: 'Atenção Aprovações Pendentes Nome Aprovador' },
    { value: 1009, text: 'Aprovação Concluída Nome Lançador' },
    { value: 1011, text: 'Aprovação Concluída Nome Aprovador' },
    { value: 1012, text: 'Aprovação Concluída Nome Aprovador' },
    { value: 1014, text: 'Aprovação Concluída Nome Lançador' },
    { value: 1020, text: 'Aprovação Realizada Nome Lançador' },
    { value: 1021, text: 'Aprovação Realizada Nome do Aprovador IB AP2' },
    { value: 1022, text: 'Aprovação Concluída Nome Aprovador' },
    { value: 1023, text: 'Aprovação Concluída Nome do Lançador 2 IB AP6' },
    { value: 1024, text: 'Aprovação Pendente IB Pagamentos' },
    { value: 1025, text: 'Pagamento Reprovado Nome Aprovador' },
    { value: 1026, text: 'Pagamento Reprovado Nome Lançador' },
    { value: 1027, text: 'Pagamento Modificado' },
    { value: 1040, text: 'Confirme Seu Email' },
    { value: 1041, text: 'Seu Perfil Foi Atualizado' },
    { value: 1042, text: 'Dado Cadastral Atualizado' },
    { value: 1060, text: 'Solicitação de alteração senha eletrônica' },
    { value: 1061, text: 'Solicitação de senha eletrônica aprovada' },
    { value: 1062, text: 'Solicitação de senha eletrônica reprovada' },
    { value: 1063, text: 'Senha Acesso Alterada' },
    { value: 1064, text: 'Horário Acesso Conta Alterado' },
    { value: 1080, text: 'Solicitação de encerramento de conta' },
    { value: 1081, text: 'Encerramento Conta Concluída' },
    { value: 1082, text: 'Encerramento Conta Não Concluída' },
    { value: 1100, text: 'Contratação Crédito Solicitada' },
    { value: 1101, text: 'Tipo Crédito Inclusão Novo Assinante' },
    { value: 1102, text: 'Tipo Crédito Novo Assinante Incluído' },
    { value: 1103, text: 'Tipo Crédito Assinante Não Incluído' },
    { value: 1104, text: 'Tipo Crédito Edição Assinante' },
    { value: 1105, text: 'Tipo Crédito Edição Assinante Concluída' },
    { value: 1106, text: 'Tipo Crédito Edição Assinante Não Concluída' },
    { value: 1107, text: 'Tipo Crédito Exclusão Assinante' },
    { value: 1108, text: 'Tipo Crédito Assinante Excluído' },
    { value: 1109, text: 'Contratação Crédito' },
    { value: 1110, text: 'Lembrete Assinatura Pendente' },
    { value: 1120, text: 'Boleto Recorrente Não Emitido' },
    { value: 1140, text: 'Boleto Compartilhado Com Você' },
    { value: 1141, text: 'Comprovante Transferência Tipo Transferência' },
    { value: 1142, text: 'Nome Cedente Link Pagamento' },
    { value: 1143, text: 'Nome Cedente Cobrança Via QR Code' },
    { value: 1144, text: 'Comprovantes Transferência' },
    { value: 1160, text: 'Sua Chave Pix Foi Cadastrada' },
    { value: 1161, text: 'Solicitação Portabilidade Chave Pix Recebida' },
    { value: 1162, text: 'Portabilidade Chave Pix Concluída' },
    { value: 1163, text: 'Solicitação Portabilidade Chave Pix Expirada' },
    { value: 1164, text: 'Portabilidade Chave Pix Recusada' },
    { value: 1165, text: 'Solicitação Reivindicação Chave Pix Recebida' },
    { value: 1166, text: 'Reivindicação Chave Pix Concluída' },
    { value: 1167, text: 'Reivindicação Chave Pix Não Concluída' },
    { value: 1168, text: 'Solicitação Portabilidade Chave Pix Cancelada' },
    { value: 1169, text: 'Reivindicação Chave Pix Cancelada' },
    { value: 1170, text: 'Ação Necessária Aprove Portabilidade Chave Pix' },
    { value: 1171, text: 'Chave Pix Excluída' },
    { value: 1180, text: 'Devolução Pix Realizada Com Sucesso' },
    { value: 1181, text: 'Confirmação Seu Pix Foi Enviado Com Sucesso' },
    { value: 1182, text: 'Pix Não Enviado' },
    { value: 1183, text: 'Você Recebeu Um Pix' },
    { value: 1184, text: 'Sua TEF Enviada Com Sucesso' },
    { value: 1185, text: 'TEF Não Enviada' },
    { value: 1186, text: 'Você Recebeu Uma TEF' },
    { value: 1187, text: 'Sua TED Foi Enviada' },
    { value: 1188, text: 'Falha Na TED' },
    { value: 1189, text: 'Você Recebeu Uma TED' },
    { value: 1190, text: 'Pagamento Realizado' },
    { value: 1191, text: 'Falha No Pagamento' },
    { value: 1192, text: 'Notificação Sem Alterações ACCS001' },
    { value: 1193, text: 'TEF agendada com sucesso IB' },
    { value: 1194, text: 'Agendamento TEF não realizado IB' },
    { value: 1195, text: 'TEF agendada não realizada IB' },
    { value: 1196, text: 'Pix agendado com sucesso IB' },
    {
      value: 1220,
      text: 'Processamento Planilha Transações Nome Planilha Concluído'
    },
    {
      value: 1221,
      text: 'Falha Processamento Planilha Transações Nome Planilha'
    },
    {
      value: 1222,
      text: 'Notificação de planilha processada'
    },
    {
      value: 1223,
      text: 'Notificação de planilha não processada'
    },
    { value: 1240, text: 'Processamento CNAB240 Concluído' },
    { value: 1241, text: 'CNAB240 Em Processamento' },
    { value: 1242, text: 'CNAB240 Não Processado' },
    { value: 1243, text: 'CNAB240 Processado Com Sucesso' },
    { value: 1260, text: 'Favorecido Cadastrado' },
    { value: 1261, text: 'Favorecido Excluído' },
    { value: 1262, text: 'Novo Pagador Cadastrado' },
    { value: 1263, text: 'Novo Beneficiário Cadastrado' },
    { value: 1264, text: 'Cadastro Pagador Atualizado' },
    { value: 1265, text: 'Pagador Excluído' },
    { value: 1266, text: 'Novo Grupo Pagadores Criado' },
    { value: 1267, text: 'Grupo Pagadores Excluídos' },
    { value: 1268, text: 'Cadastro Beneficiário Atualizado' },
    { value: 1269, text: 'Beneficiário Excluído' },
    { value: 1280, text: 'Novo Perfil Cobrança Criado' },
    { value: 1281, text: 'Perfil Cobrança Alterado' },
    { value: 1282, text: 'Perfil Cobrança Excluído' },
    {
      value: 1283,
      text: 'Adesão Funcionalidade Régua Comunicação Realizada IB'
    },
    { value: 1284, text: 'Nova Régua Comunicação Criada' },
    { value: 1285, text: 'Régua Comunicação Alterada' },
    { value: 1286, text: 'Régua Comunicação Excluída' },
    { value: 1300, text: 'Link Pagamento Criado' },
    { value: 1301, text: 'Boletos Recebidos Troca Cedente' },
    { value: 1302, text: 'Boletos Troca Cedente Aceitos' },
    { value: 1303, text: 'Boletos Troca Cedente Recusados' },
    { value: 1304, text: 'Boletos Enviados Troca Cedente' },
    { value: 1305, text: 'Protesto Boleto Solicitado' },
    { value: 1306, text: 'Solicitação Protesto Aceito Cartório' },
    { value: 1307, text: 'Boleto Protestado' },
    { value: 1308, text: 'Negativação Pagador Solicitada' },
    { value: 1309, text: 'Negativação Pagador Efetivada' },
    { value: 1310, text: 'Negativação Pagador Não Realizada' },
    { value: 1311, text: 'Instrução Boleto Incluída Com Sucesso' },
    { value: 1312, text: 'Boleto Cancelado' },
    { value: 1313, text: 'Adesão Funcionalidade Protesto Realizada' },
    { value: 1314, text: 'Desistência Protesto Solicitada' },
    { value: 1315, text: 'Desistência Protesto Realizada' },
    { value: 1316, text: 'Falha Desistência Protesto' },
    { value: 1317, text: 'Anuência Protesto Solicitada' },
    { value: 1318, text: 'Protesto Anuído' },
    { value: 1319, text: 'Seu Protesto Foi Anuído Pelo Cedente' },
    { value: 1320, text: 'Falha Anuência Protesto' },
    { value: 1321, text: 'Adesão Funcionalidade Negativação Realizada' },
    { value: 1322, text: 'Cancelamento Negativação Solicitado' },
    { value: 1323, text: 'Negativação Cancelada' },
    { value: 1324, text: 'Falha Cancelamento Negativação' },
    {
      value: 1325,
      text: 'Cancelamento Envio Boletos Troca Cedente Solicitado'
    },
    { value: 1326, text: 'Envio Boletos Troca Cedente Cancelado' },
    { value: 1327, text: 'Devolução Boletos Recebidos Como Caução Realizada' },
    { value: 1328, text: 'Recorrência Emissão Boletos Cancelada' },
    { value: 1329, text: 'Recorrências Emissão Boletos Canceladas' },
    { value: 1330, text: 'Recorrência Emissão Finalizada' },
    { value: 1331, text: 'Boletos Compartilhados Com Você' },
    { value: 1350, text: 'Novo Beneficiário Cadastrado Com Cedente' },
    { value: 1351, text: 'Cadastro Beneficiário Atualizado Com Cedente' },
    { value: 1352, text: 'Beneficiário Excluído Com Cedente' },
    { value: 1353, text: 'Compartilhamento QR Code - Cobrança' },
    { value: 1354, text: 'Compartilhamento QR Code - Estático' },
    { value: 1355, text: 'Código de verificação de e-mail' },
    { value: 1356, text: 'Confirmação de cadastro de token' },
    { value: 1357, text: 'Senha eletrônica bloqueada' },
    { value: 1358, text: 'Alteração de senha eletrônica' },
    { value: 1359, text: 'Notificar Bloqueio Sisbajud' },
    { value: 1360, text: 'Notificar Bloqueio Sisbajud Vazio' },
    { value: 1361, text: 'Solicitação de senha eletrônica cancelada' },
    {
      value: 1362,
      text: 'Notificação de Segurança - Divergência de Dispositivo'
    },
    { value: 1371, text: 'Conta ativada - Operador COM biometria' },
    { value: 1372, text: 'Conta ativada - Operador SEM biometria' },
    { value: 1373, text: 'Conta ativada - Sócio e representante legal' },
    { value: 1374, text: 'Conta ativada - Operador com acesso ao app' },
    { value: 1377, text: 'Aprovação Pendente IB Transação' },
    { value: 1378, text: 'Aprovação Pendente Lançador IB' },
    { value: 1375, text: 'Boleto emissão envio e-mail' },
    { value: 1376, text: 'Adesão Funcionalidade Régua Comunicação Realizada' },
    { value: 1379, text: 'Fatura fechada' },
    { value: 1380, text: 'Boleto parcelado emissão envio e-mail' },
    { value: 1381, text: 'Falha de envio de protesto IB' },
    { value: 1382, text: 'Liquidação de protesto IB' },
    { value: 1383, text: 'Comprovante - Pix Automático' },
    { value: 1384, text: 'Comprovante - Autorização Pix Automático' },
    {
      value: 1385,
      text: 'Solicitação de Devolução MED com Bloqueio Manual / Falha SPI'
    },
    { value: 1450, text: 'Solicitação de Devolução Automática Criada IB' },
    {
      value: 1451,
      text: 'Solicitação de Devolução Automática Falha Criação BackOffice'
    },
    { value: 1452, text: 'Recuperação de senha - CMS' },
    { value: 1453, text: 'Primeiro acesso - CMS' },
    { value: 1454, text: 'Compartilhar Link - CMS' },
    { value: 1650, text: 'Alerta de Envio/Devolução Suspeito' },
    { value: 1651, text: 'Alerta BACEN - Recebimento ADMI004' }
  ],
  TemplateSituacao: [
    { value: 1, text: 'Ativado' },
    { value: 2, text: 'Desativado' }
  ],
  HorarioInicioLimitePeriodo: [
    { value: 1, text: '20:00' },
    { value: 2, text: '22:00' }
  ],
  SituacaoLimitePeriodo: [
    { value: 3, text: 'Ativo' },
    { value: 4, text: 'Inativo' }
  ],
  OrigemAlteracaoTarifario: [
    { value: 1, text: 'Inserção' },
    { value: 2, text: 'Alteração' }
  ],
  SituacaoTarifa: [
    { value: 1, text: 'Pendente de Pagamento' },
    { value: 2, text: 'Pago' },
    { value: 3, text: 'Cancelado' }
  ],
  TipoParticipanteSPI: [
    { value: 1, text: 'Direta' },
    { value: 2, text: 'Indireta' }
  ],
  ModalidadeParticipacaoPix: [
    { value: 1, text: 'Provedor de Conta Transacional' },
    { value: 2, text: 'Ente Governamental' },
    { value: 3, text: 'Liquidante Especial' }
  ],
  SituacaoTransacaoDescricao: [
    { value: 0, text: 'Pendente' },
    { value: 1, text: 'Registrando' },
    { value: 2, text: 'Registrado' },
    { value: 3, text: 'Cancelado' },
    { value: 4, text: 'Confirmado' },
    { value: 50, text: 'Pendente Reprocessamento' },
    { value: 97, text: 'Não Processada' },
    { value: 98, text: 'Erro de Negocio' },
    { value: 99, text: 'Erro de Sistema' }
  ],
  ApiOrigem: [
    { value: 0, text: 'BackOffice' },
    { value: 1, text: 'API FrontEnd' },
    { value: 2, text: 'API Externa' },
    { value: 3, text: 'Retaguarda' },
    { value: 4, text: 'Onboarding' },
    { value: 5, text: 'Onboarding Múltiplo' },
    { value: 99, text: 'Outros' }
  ],
  TipoMotivoRecusa: [
    { value: 1, text: 'Existe marcação de fraude.' },
    {
      value: 2,
      text: 'O nome está divergente com o consultado na receita federal.'
    },
    { value: 3, text: 'A situação fiscal está diferente de regular.' },
    {
      value: 4,
      text: 'O documento federal informado pertence a um menor de idade.'
    },
    {
      value: 6,
      text: 'Não é possível abrir a conta. Restrição identificada no BC Protege+.'
    },
    { value: 7, text: 'Recusa manual.' },
    { value: 99, text: 'Outros' }
  ],
  TipoReivindicacaoPortabilidade: [
    { value: 1, text: 'Reivindicação' },
    { value: 2, text: 'Portabilidade' }
  ],
  TipoSolicitacaoPortabilidade: [
    { value: 1, text: 'Efetuada' },
    { value: 2, text: 'Recebida' }
  ],
  SituacoesReivindicacoesDoacoes: [
    { value: 3, text: 'Cancelado' },
    { value: 4, text: 'Confirmado' }
  ],
  TiposJurosQRCode: [
    { value: 5, text: 'Isento' },
    { value: 1, text: 'Valor (dias corridos)' },
    { value: 2, text: 'Percentual ao dia (dias corridos)' },
    { value: 3, text: 'Percentual ao mês (dias corridos)' }
  ],
  TipoArquivoRelatorio: [
    { value: 1, text: 'PDF' },
    { value: 2, text: 'CSV' },
    { value: 3, text: 'XLSX' },
    { value: 4, text: 'ZIP' },
    { value: 5, text: 'OFX' }
  ],
  TipoRelatorio: [
    { value: 1, text: 'Boletos Registrados' },
    { value: 2, text: 'Movimentações por Conta' },
    { value: 3, text: 'Exportação Contabilização' },
    { value: 4, text: 'Extrato Conta' },
    { value: 5, text: 'Saldo' },
    { value: 6, text: 'Consulta de Boletos' },
    { value: 12, text: 'Bacen' },
    { value: 13, text: 'Log Limite Adicional' },
    { value: 15, text: 'Log Limite Operador' },
    { value: 16, text: 'Log Limite Operador Adicional' },
    { value: 18, text: 'Tarifa Recorrente' },
    { value: 19, text: 'Tarifário' },
    { value: 20, text: 'Log Limite Operação' },
    { value: 21, text: 'Operador' },
    { value: 24, text: 'Histórico Favorecido' },
    { value: 25, text: 'Split' },
    { value: 26, text: 'DDA Pagador Eletrônico' },
    { value: 27, text: 'Saldo por Parceiro' },
    { value: 28, text: 'Cessão Boleto' },
    { value: 30, text: 'APIX1201' }
  ],
  SituacaoRelatorio: [
    { value: 1, text: 'Pendente' },
    { value: 2, text: 'Processando' },
    { value: 3, text: 'Processado' },
    { value: 4, text: 'Erro' }
  ],
  TipoBoleto: [
    { value: 1, text: 'Híbrido' },
    { value: 2, text: 'CIP' }
  ],
  TipoComunicacaoTemplate: [
    { value: 1, text: 'Padrão' },
    { value: 2, text: 'Personalizado' },
    { value: 3, text: 'Desativado' }
  ],
  TipoInformativo: [
    { value: 1, text: 'Comunicado' },
    { value: 2, text: 'Publicidade' },
    { value: 3, text: 'Alerta' }
  ],
  TipoDestinatario: [
    { value: 1, text: 'Operador Backoffice' },
    { value: 2, text: 'Operador Retaguarda' },
    { value: 3, text: 'Cliente' }
  ],
  SituacaoQRCode: [
    { value: 4, text: 'Todos' },
    { value: 1, text: 'Registrado' },
    { value: 2, text: 'Cancelado' },
    { value: 3, text: 'Pago' }
  ],
  ServicoGokei: [
    { value: 3, text: 'SPB/NPC' },
    { value: 4, text: 'SPI' }
  ],
  TipoInfracao: [
    { value: 1, text: 'Associada a uma solicitação de devolução' },
    { value: 2, text: 'Cancelamento de devolução' }
  ],
  MotivoFraude: [
    { value: 1, text: 'Golpe/Estelionato' },
    { value: 2, text: 'Transação não autorizada' },
    { value: 3, text: 'Crime de coerção' },
    { value: 4, text: 'Acesso e autorização fraudulenta' },
    { value: 5, text: 'Outros' },
    { value: 6, text: 'Sem conhecimento' }
  ],
  StatusInfracao: [
    { value: 1, text: 'Aberto' },
    { value: 2, text: 'Reconhecida' },
    { value: 3, text: 'Fechada' },
    { value: 4, text: 'Cancelada' }
  ],
  TipoFraude: [
    { value: 1, text: 'Falsidade ideológica' },
    { value: 2, text: 'Conta-laranja' },
    { value: 3, text: 'Conta golpista' },
    { value: 4, text: 'Outro' }
  ],
  ResultadoAnalise: [
    { value: 1, text: 'Aceitar Infração' },
    { value: 2, text: 'Rejeitar Infração' }
  ],
  RazaoDevolucao: [
    { value: 1, text: 'Fundada suspeita de fraude' },
    { value: 2, text: 'Falha operacional do PSP do pagador' },
    { value: 3, text: 'Cancelamento da devolução' }
  ],
  RazaoDevolucaoSimplificado: [
    { value: 1, text: 'Fraude' },
    { value: 2, text: 'Falha Operacional' }
  ],
  StatusDevolucao: [
    { value: 1, text: 'Aberto' },
    { value: 2, text: 'Fechada' },
    { value: 3, text: 'Cancelada' }
  ],
  ResultadoAnaliseDevolucao: [
    { value: 1, text: 'Totalmente aceita' },
    { value: 2, text: 'Parcialmente aceita' },
    { value: 3, text: 'Rejeitada' }
  ],
  MotivoRejeicaoDevolucao: [
    { value: 1, text: 'Falta de saldo na conta do cliente' },
    { value: 2, text: 'Relacionamento com cliente encerrado' },
    { value: 3, text: 'Forma de solicitação inválida' },
    { value: 4, text: 'Motivo genérico' }
  ],
  TipoCargos: [
    { value: 1, text: 'Diretor' },
    { value: 2, text: 'Técnico' },
    { value: 3, text: 'Institucional' }
  ],
  Trimestres: [
    { value: 1, text: 'Janeiro a Março' },
    { value: 2, text: 'Abril a Junho' },
    { value: 3, text: 'Julho a Setembro' },
    { value: 4, text: 'Outubro a Dezembro' }
  ],
  TipoArquivoBacen: [
    { value: 'CONGLOME', text: 'CONGLOME' },
    { value: 'USUREMOT', text: 'USUREMOT' },
    { value: 'ESTATCRT', text: 'ESTATCRT' },
    { value: 'ESTATATM', text: 'ESTATATM' },
    { value: 'TRANSOPA', text: 'TRANSOPA' },
    { value: 'OPEINTRA', text: 'OPEINTRA' },
    { value: 'CONTATOS', text: 'CONTATOS' },
    { value: 'DATABASE', text: 'DATABASE' }
  ],
  TipoOperacaoBacen: [
    { value: 'Operacao', text: 'Operação' },
    { value: 'OperacaoTicket', text: 'Operação de Ticket' },
    { value: 'OperacaoIntra', text: 'Operação Intrabancária' }
  ],
  OrigemTransacaoTicket: [
    { value: 0, text: 'TED' },
    { value: 100, text: 'Transferência Interna' },
    { value: 200, text: 'Pagamento de Boleto' },
    { value: 300, text: 'Envio de PIX' },
    { value: 301, text: 'Devolução de PIX' },
    { value: 380, text: 'Leitura QR Code Estático' }
  ],
  SituacaoTicketRetorno: [
    { value: 0, text: 'Pendente' },
    { value: 1, text: 'Sucesso' },
    { value: 2, text: 'Erro' },
    { value: 3, text: 'Agendada' },
    { value: 4, text: 'Aguardando aprovação' },
    { value: 5, text: 'Cancelada' },
    { value: 6, text: 'Reprovada' },
    { value: 7, text: 'Aguardando Retorno' }
  ],
  SituacaoFavorecido: [
    { value: 0, text: 'Pendente' },
    { value: 2, text: 'Rejeitado' },
    { value: 3, text: 'Ativo' }
  ],
  TipoCadastroFavorecido: [
    { value: 1, text: 'Transferência e TED' },
    { value: 2, text: 'PIX' }
  ],
  SituacaoNotificacao: [
    { value: 1, text: 'Registrada' },
    { value: 2, text: 'Cancelada' },
    { value: 3, text: 'Lida' }
  ],
  TipoCadastroPix: [
    { value: 1, text: 'Chave' },
    { value: 2, text: 'Dados Bancários' }
  ],
  SituacaoDevolucaoBoleto: [
    { value: 0, text: 'Pendente' },
    { value: 1, text: 'Creditado' },
    { value: 2, text: 'Cancelado' },
    { value: 99, text: 'Erro nos Dados' }
  ],
  TipoTransacaoLimitesOperacao: [
    { value: 1, text: 'Saque' },
    { value: 2, text: 'Compra' },
    { value: 3, text: 'TED' },
    { value: 4, text: 'Transferência' },
    { value: 5, text: 'Pagamento de Boleto' },
    { value: 6, text: 'Pix' },
    { value: 8, text: 'Pix Automático' },
    { value: 10, text: 'Pix Aproximação' }
  ],
  PeriodoLimiteOperacao: [
    { value: 1, text: 'Diurno' },
    { value: 2, text: 'Noturno' },
    { value: 3, text: 'Diário' }
  ],
  TipoPessoa: [
    { value: 1, text: 'Fisica' },
    { value: 2, text: 'Jurídica' }
  ],
  SituacaoLimiteFavorecido: [
    { value: 1, text: 'Ativado' },
    { value: 2, text: 'Desativado' }
  ],
  HoraInicioLimiteOperacao: [
    { value: '06:00', text: '06:00' },
    { value: '07:00', text: '07:00' },
    { value: '08:00', text: '08:00' },
    { value: '00:00', text: '00:00' }
  ],
  HoraFimLimiteOperacao: [
    { value: '20:00', text: '20:00' },
    { value: '21:00', text: '21:00' },
    { value: '22:00', text: '22:00' },
    { value: '23:59', text: '23:59' }
  ],
  SituacaoLimiteOperacao: [
    { value: 1, text: 'Pendente' },
    { value: 2, text: 'Reprovado' },
    { value: 3, text: 'Ativo' },
    { value: 4, text: 'Inativo' }
  ],
  ModeloConta: [
    { value: 1, text: 'Movimento' },
    { value: 2, text: 'Escrow' },
    { value: 3, text: 'Vinculada' }
  ],
  TipoTranferenciaContaVinculada: [
    { value: 1, text: 'Apenas para a conta vinculada' },
    { value: 2, text: 'Para todas as contas' }
  ],
  ResultadoAnaliseInfracao: [
    { value: 1, text: 'Concordou' },
    { value: 2, text: 'Discordou' }
  ],
  SituacaoCadastroFavorecido: [
    { value: 1, text: 'Com restrição' },
    { value: 2, text: 'Sem restrição' },
    { value: 3, text: 'Sem serviço ' }
  ],
  SituacaoFavorecidoConsulta: [
    { value: 3, text: 'Ativo' },
    { value: 4, text: 'Desativado' }
  ],
  SituacaoFavorecidoHistorico: [
    { value: 2, text: 'Rejeitado' },
    { value: 3, text: 'Aprovado' },
    { value: 4, text: 'Desativado' }
  ],
  SituacaoAprovacaoAutomaticaFavorecido: [
    { value: 1, text: 'Considerar do Parceiro' },
    { value: 2, text: 'Sim' },
    { value: 3, text: 'Não' }
  ],
  SituacaoEncerramentoConta: [
    { value: 1, text: 'Disponível' },
    { value: 2, text: 'Necessário Ação Manual' },
    { value: 3, text: 'Não Disponível' }
  ],
  SituacaoArquivoEncerramentoContaLote: [
    { value: 1, text: 'Pendente' },
    { value: 2, text: 'Processando' },
    { value: 3, text: 'Processado' },
    { value: 99, text: 'Erro' }
  ],
  TipoEncerramentoConta: [
    { value: 1, text: 'Individual' },
    { value: 2, text: 'Em Lote' }
  ],
  ContextoAnalise: [
    { value: 1, text: 'Correntista' },
    { value: 2, text: 'Operador Backoffice' },
    { value: 3, text: 'Operador Retaguarda' },
    { value: 4, text: 'Operador Frontend' },
    { value: 5, text: 'Conta' },
    { value: 6, text: 'Split' },
    { value: 7, text: 'Limite de Operação' }
  ],
  PermissoesAnaliseOperador: {
    Criação: 1,
    Edição: 1 << 1,
    Vínculo: 1 << 2
  },
  TipoSolicitacaoLimite: [
    { value: 1, text: 'Fixo' },
    { value: 2, text: 'Temporário' }
  ],
  TipoLimiteArquivoLimiteOperacao: [
    { value: 1, text: 'Padrão BMP' },
    { value: 2, text: 'Parceiro' },
    { value: 3, text: 'Conta' }
  ],
  SituacaoArquivoLimiteOperacao: [
    { value: 0, text: 'Pendente' },
    { value: 1, text: 'Importando' },
    { value: 2, text: 'Importado' },
    { value: 3, text: 'Processando' },
    { value: 4, text: 'Processado' },
    { value: 99, text: 'Erro Validação' }
  ],
  SituacaoArquivoLimiteOperacaoLinha: [
    { value: 0, text: 'Pendente' },
    { value: 1, text: 'Processando' },
    { value: 2, text: 'Aprovado' },
    { value: 3, text: 'Reprovado' },
    { value: 99, text: 'Erro Validação' }
  ],
  SituacaoSolicitacaoMfaFisico: [
    { value: 0, text: 'Pendente' },
    { value: 1, text: 'Aprovado' },
    { value: 2, text: 'Reprovado' },
    { value: 3, text: 'Expirado' }
  ],
  SituacaoLimiteEspecialParceiro: [
    { value: 0, text: 'Desativado' },
    { value: 1, text: 'Ativado' },
    { value: 2, text: 'Suspenso' }
  ],
  PrincipalAcessoBanco: [
    { value: 0, text: 'RSFN' },
    { value: 1, text: 'Internet' }
  ],
  SituacaoCadastroAnalise: [
    { value: 0, text: 'Não aplicável' },
    { value: 1, text: 'Sem restrição' },
    { value: 2, text: 'Com restrição' },
    { value: 3, text: 'Sem serviço' }
  ],
  ContextoOrigemAntifraude: [
    { value: 0, text: 'Nenhum' },
    { value: 1, text: 'Favorecido' },
    { value: 2, text: 'OperadorBackOffice' },
    { value: 3, text: 'OperadorRetaguarda' },
    { value: 4, text: 'OperadorFrontEnd' },
    { value: 5, text: 'Correntista' }
  ],
  SituacaoMfa: [
    { value: 1, text: 'Iniciado' },
    { value: 2, text: 'Finalizado' },
    { value: 3, text: 'Expirado' },
    { value: 4, text: 'Cancelado' }
  ],
  InstituicaoParticipanteSPI: [
    { value: 0, text: 'Instituição de Pagamento' },
    { value: 1, text: 'Sociedade de Crédito Direto' },
    {
      value: 2,
      text: 'Instituição de Pagamento não sujeita à autorização pelo BCB'
    },
    { value: 3, text: 'Sociedade de Crédito, Financiamento e Investimento' },
    { value: 4, text: 'Associação de Poupança e Empréstimo' },
    { value: 5, text: 'Banco Múltiplo' },
    { value: 6, text: 'Banco Comercial' },
    { value: 7, text: 'Banco Múltiplo Cooperativo' },
    { value: 8, text: 'Banco de Câmbio' },
    { value: 9, text: 'Sociedade de Crédito ao Microempreendedor' },
    { value: 10, text: 'Cooperativa de Crédito' },
    { value: 11, text: 'Caixa Econômica Federal' },
    { value: 12, text: 'Sociedade Corretora de TVM' },
    { value: 13, text: 'Sociedade Distribuidora de TVM' },
    { value: 14, text: 'Governo' }
  ],
  TipoParticipantePix: [
    { value: 0, text: 'Facultativa' },
    { value: 1, text: 'Obrigatória' }
  ],
  StatusEmProducaoParticipanteSPI: [
    { value: 0, text: 'Ativo em operação plena' },
    { value: 1, text: 'Ativo em operação restrita' }
  ],
  TipoSolicitacaoSenhaEletronica: [
    { value: 1, text: 'Recadastramento' },
    { value: 2, text: 'Desbloqueio' }
  ],
  SituacaoSolicitacaoSenhaEletronica: [
    { value: 1, text: 'Pendente' },
    { value: 2, text: 'Negada por Fraude' },
    { value: 3, text: 'Aprovado' },
    { value: 4, text: 'Reprovado' },
    { value: 5, text: 'Expirado' },
    { value: 6, text: 'Concluído' },
    { value: 7, text: 'Cancelado' }
  ],
  HoraAtivacaoOperador: [
    { value: '06:00', text: '06:00' },
    { value: '07:00', text: '07:00' },
    { value: '08:00', text: '08:00' },
    { value: '09:00', text: '09:00' }
  ],
  HoraInativacaoOperador: [
    { value: '18:00', text: '18:00' },
    { value: '19:00', text: '19:00' },
    { value: '20:00', text: '20:00' },
    { value: '21:00', text: '21:00' }
  ],
  TipoBloqueio: [
    { value: 0, text: 'Sem Bloqueio' },
    { value: 1, text: 'Débito' },
    { value: 2, text: 'Crédito' },
    { value: 3, text: 'Débito e Crédito' }
  ],
  TipoAgente: [
    { value: 1, text: 'Gestor' },
    { value: 2, text: 'Indicador' }
  ],
  TipoPerfilOperadorOnboarding: {
    Nenhum: 0,
    Administrador: 1,
    Analista: 1 << 1,
    Aprovador: 1 << 2
  },
  TiposSituacaoOperadorOnboarding: [
    { value: 0, text: 'Cadastrado' },
    { value: 1, text: 'Ativado' },
    { value: 2, text: 'Desativado' }
  ],
  SituacaoSublimiteQRCodePix: [
    { value: 0, text: 'Todos' },
    { value: 1, text: 'Ativado' },
    { value: 2, text: 'Desativado' }
  ],
  SituacaoContaCartao: [
    { value: 0, text: 'Solicitado' },
    { value: 1, text: 'Aprovado' },
    { value: 2, text: 'Ativo' },
    { value: 3, text: 'Bloqueado' },
    { value: 99, text: 'Aguardando avaliação KYC (Know Your Customer)' }
  ],
  HoraAtivacaoLimiteAberturaContaDiurno: [
    { value: '06:00', text: '06:00' },
    { value: '07:00', text: '07:00' },
    { value: '08:00', text: '08:00' }
  ],
  HoraInativacaoLimiteAberturaContaDiurno: [
    { value: '18:00', text: '18:00' },
    { value: '19:00', text: '19:00' },
    { value: '20:00', text: '20:00' }
  ],
  DiasSemana: [
    { value: 0, text: 'Nenhum' },
    { value: 1, text: 'Segunda-Feira' },
    { value: 1 << 1, text: 'Terça-Feira' },
    { value: 1 << 2, text: 'Quarta-Feira' },
    { value: 1 << 3, text: 'Quinta-Feira' },
    { value: 1 << 4, text: 'Sexta-Feira' },
    { value: 1 << 5, text: 'Sábado' },
    { value: 1 << 6, text: 'Domingo' }
  ],
  DiaSemana: [
    { value: 0, text: 'Domingo' },
    { value: 1, text: 'Segunda-Feira' },
    { value: 2, text: 'Terça-Feira' },
    { value: 3, text: 'Quarta-Feira' },
    { value: 4, text: 'Quinta-Feira' },
    { value: 5, text: 'Sexta-Feira' },
    { value: 6, text: 'Sábado' }
  ],
  FrequenciaAgendamento: [
    { value: 1, text: 'Diariamente' },
    { value: 2, text: 'Semanalmente' }
  ],
  TipoAcesso: [
    { value: 1, text: 'Master' },
    { value: 2, text: 'Operador' }
  ],
  TipoAcessoFrontEnd: [
    { value: 1, text: 'Padrão' },
    { value: 2, text: 'Personalizado' }
  ],
  TipoProgramacao: [
    { value: 1, text: 'Programada Total' },
    { value: 2, text: 'Programada Valor' },
    { value: 3, text: 'Programada Percentual' }
  ],
  TipoPermissaoGestaoAcesso: [
    { value: 1, text: 'DBS.IB.Master' },
    { value: 2, text: 'DBS.IB.VTransacoes' },
    { value: 3, text: 'DBS.IB.IAETransacoes' },
    { value: 4, text: 'DBS.IB.ATransacoes' },
    { value: 5, text: 'DBS.IB.VExtrato' },
    { value: 6, text: 'DBS.IB.VLimite' },
    { value: 7, text: 'DBS.IB.IALimite' },
    { value: 8, text: 'DBS.IB.VIEmissao' },
    { value: 9, text: 'DBS.IB.VGestaoCobranca' },
    { value: 10, text: 'DBS.IB.IAEGestaoCobranca' },
    { value: 11, text: 'DBS.IB.AGestaoCobranca' },
    { value: 12, text: 'DBS.IB.VTarifas' }
  ],
  TipoSocio: [
    { value: 1, text: 'Parceiro' },
    { value: 2, text: 'Procurador' },
    { value: 3, text: 'Representante Legal' },
    { value: 4, text: 'Outro' }
  ],
  TipoHorarioRepasseSaldo: [
    { value: 1, text: 'Automático' },
    { value: 2, text: 'Personalizado' }
  ],
  TipoVinculoConta: [
    { value: 1, text: 'Operador' },
    { value: 2, text: 'Correntista' }
  ],
  SituacaoOnboarding: [
    { value: 1, text: 'Em análise' },
    { value: 2, text: 'Aprovado' },
    { value: 3, text: 'Reprovado' },
    { value: 4, text: 'Em consulta' }
  ],
  TipoProtestoBoleto: [
    { value: 0, text: 'Desabilitado' },
    { value: 1, text: 'Habilitado (Apenas Manual)' },
    { value: 2, text: 'Habilitado (Manual + Automático)' }
  ],
  TipoTemplateNotificacao: [
    { value: 1, text: 'Transferência enviada' },
    { value: 2, text: 'Transferência recebida' },
    { value: 3, text: 'Transferência agendada' },
    { value: 4, text: 'Transferência agendada concluída' },
    { value: 5, text: 'Transferência agendada não concluída' },
    { value: 6, text: 'Devolução Pix concluída' },
    { value: 7, text: 'Solicitação de limite' },
    { value: 8, text: 'Limite aprovado' },
    { value: 9, text: 'Limite não aprovado' },
    { value: 10, text: 'Novo cadastro de favorecido' },
    { value: 11, text: 'Favorecido não cadastrado' },
    { value: 12, text: 'Desbloqueio de cartão' },
    { value: 13, text: 'Cartão bloqueado' },
    { value: 14, text: 'Compra aprovada' },
    { value: 15, text: 'Compra não aprovada' },
    { value: 16, text: 'Compra não aprovada - cartão bloqueado' },
    { value: 17, text: 'Novidade em pagamentos de boletos' },
    { value: 18, text: 'Novos boletos para você acompanhar' },
    { value: 19, text: 'Analise da portabilidade pix em andamento' },
    { value: 20, text: 'Portabilidade pix efetuada com sucesso' },
    { value: 21, text: 'Processamento de registro CNAB concluído' },
    { value: 22, text: 'Aprovação pendente' },
    { value: 23, text: 'Aprovação concluída' },
    { value: 24, text: 'Transação Agendada PIX' },
    { value: 25, text: 'Falha na Transação Agendada PIX' },
    { value: 26, text: 'Perfil atualizado' },
    { value: 27, text: 'Dado cadastral atualizado' },
    { value: 28, text: 'Senha de acesso alterada' },
    {
      value: 29,
      text: 'Solicitação de alteração de senha eletrônica aprovada'
    },
    {
      value: 30,
      text: 'Solicitação de alteração de senha eletrônica reprovada'
    },
    { value: 31, text: 'Horário de acesso à conta alterado' },
    { value: 32, text: 'Senha eletrônica alterada' },
    { value: 34, text: 'Pix Automático - Autorização Solicitada' },
    { value: 35, text: 'Pix Automático - Autorização Confirmada' },
    { value: 36, text: 'Pix Automático - Autorização Cancelada' },
    { value: 37, text: 'Pix Automático - Agendamento Confirmado' },
    { value: 38, text: 'Pix Automático - Agendamento Não Confirmado' },
    { value: 39, text: 'Pix Automático - Agendamento Cancelado' },
    { value: 40, text: 'Pix Automático - Agendamento Não Realizado' },
    { value: 41, text: 'Pix Automático - Pagamento Realizado' },
    { value: 42, text: 'Pix Automático - Pagamento Rejeitado por Saldo' },
    {
      value: 43,
      text: 'Pix Automático - Pagamento Rejeitado por Saldo (2ª tentativa)'
    },
    {
      value: 44,
      text: 'Pix Automático - Pagamento Rejeitado por Saldo (3ª tentativa)'
    },
    { value: 45, text: 'Pix Automático - Limite Diário Excedido' },
    { value: 46, text: 'Pix Automático - Máximo Autorizado Excedido' },
    { value: 47, text: 'Transferência não concluída' },
    { value: 52, text: 'Bloqueio de Recurso' },
    { value: 53, text: 'Desbloqueio de Recurso' },
    { value: 54, text: 'Envio de Devolução' },
    { value: 55, text: 'Recebimento de Devolução' }
  ],
  SituacaoAnaliseDocumento: [
    { value: 1, text: 'Documento em análise' },
    { value: 2, text: 'Aprovado' },
    { value: 3, text: 'Reprovado' },
    { value: 4, text: 'Pendente' }
  ],
  TipoQRCodeDinamico: [
    { value: 0, text: 'Todos' },
    { value: 1, text: 'Cobrança' },
    { value: 2, text: 'Imediato' }
  ],
  TipoEnvioPix: [
    { value: 0, text: 'Dados Bancários' },
    { value: 1, text: 'Chave' }
  ],
  TipoRepasse: [
    { value: 1, text: 'Interno' },
    { value: 2, text: 'Externo' }
  ],
  SituacaoNotificacaoInfracaoPix: [
    { value: 1, text: 'Sem notificação' },
    { value: 2, text: 'Notificação enviada' },
    { value: 3, text: 'Notificação cancelada' }
  ],
  TipoMensagemCCS: [
    { value: 'CCS0001', text: 'Relacionamento de Pessoa (CCS0001)' },
    { value: 'CCS0003', text: 'Pessoas Vinculadas à Conta (CCS0003)' }
  ],
  SituacaoSolicitacaoCCS: [
    { value: 1, text: 'Pendente' },
    { value: 2, text: 'Respondida' }
  ],
  SituacaoInformacaoCCS: [
    { value: 1, text: 'Não Informar' },
    { value: 2, text: 'Informar' },
    { value: 3, text: 'Liminar' },
    { value: 4, text: 'Relacionamento Inexistente' },
    { value: 5, text: 'Conta Ativa' },
    { value: 6, text: 'Conta Inexistente' },
    { value: 7, text: 'Conta Encerrada' },
    { value: 8, text: 'Conta sob Liminar' }
  ],
  SituacaoRetornoCCS: [
    { value: 1, text: 'Pendente' },
    { value: 2, text: 'OK' },
    { value: 99, text: 'Erro' }
  ],
  TipoArquivoCCS: [
    { value: 1, text: 'CCS0001' },
    { value: 2, text: 'CCS0003' }
  ],
  TitularidadeConta: [
    { value: 1, text: 'Titular' },
    { value: 2, text: 'Co-Titular' }
  ],
  SituacaoFavorecidoLoteLinha: [
    { value: 1, text: 'Pendente' },
    { value: 2, text: 'Cadastrado' },
    { value: 3, text: 'Pendente aprovação' },
    { value: 4, text: 'Não disponível' },
    { value: 5, text: 'Erro de sistema' },
    { value: 6, text: 'Rejeitado' }
  ],
  SituacaoArquivoCadastroFavorecidoLote: [
    { value: 1, text: 'Pendente' },
    { value: 2, text: 'Processando' },
    { value: 3, text: 'Processado' },
    { value: 99, text: 'Erro' }
  ],
  SituacaoEstatisticasPessoaLoteArquivo: [
    { value: 1, text: 'Recebido' },
    { value: 2, text: 'Processando' },
    { value: 3, text: 'Processado' },
    { value: 4, text: 'Processado com erros' },
    { value: 99, text: 'Erro' }
  ],
  OrigemCadastroFavorecido: [
    { value: 1, text: 'Individual' },
    { value: 2, text: 'Lote' }
  ],
  SituacaoTransacionalCartao: [
    { value: 0, text: 'Recusado' },
    { value: 1, text: 'Aprovado' }
  ],
  TipoPerguntaQuiz: [
    { value: 1, text: 'Primeiro nome' },
    { value: 2, text: 'Dia de nascimento' },
    { value: 3, text: 'Mês de nascimento' },
    { value: 4, text: 'E-mail cadastrado' },
    { value: 5, text: 'Telefone cadastrado' },
    { value: 6, text: 'Primeiro nome da mãe' },
    { value: 7, text: 'Ano de nascimento' }
  ],
  SituacaoOficio: [
    { value: 1, text: 'aguardando processamento' },
    { value: 2, text: 'falha' },
    { value: 3, text: 'sucesso' },
    { value: 4, text: 'situação indeterminada' }
  ],
  SituacaoDepositoJudicial: [
    { value: 1, text: 'aguardando processamento' },
    { value: 2, text: 'falha' },
    { value: 3, text: 'sucesso' },
    { value: 4, text: 'situação indeterminada' }
  ],
  SituacaoPerguntaQuiz: [
    { value: 1, text: 'Pendente' },
    { value: 2, text: 'Correto' },
    { value: 3, text: 'Errado' }
  ],
  SituacaoQuiz: [
    { value: 1, text: 'Pendente' },
    { value: 2, text: 'Aprovado' },
    { value: 3, text: 'Reprovado' }
  ],
  TipoAcessoOperadorConta: [
    { value: 1, text: 'Master' },
    { value: 2, text: 'Operador' }
  ],
  SituacaoOperadorConta: [
    { value: 1, text: 'Em análise' },
    { value: 2, text: 'Aguardando biometria' },
    { value: 3, text: 'Cancelado' },
    { value: 4, text: 'Reprovado' },
    { value: 5, text: 'Ativo' },
    { value: 6, text: 'Inativo' },
    { value: 7, text: 'Excluído' }
  ],
  SituacaoDesbloqueioQuiz: [
    { value: 1, text: 'Bloqueado' },
    { value: 2, text: 'Desbloqueado' }
  ],
  NivelConfiguracaoParametrizacaoAlerta: [
    { value: 1, text: 'Global' },
    { value: 2, text: 'Parceiro' },
    { value: 3, text: 'Conta' }
  ],
  NivelPermissaoLiberacaoEspecial: [
    { value: 1, text: 'Parceiro' },
    { value: 2, text: 'Conta' }
  ],
  ComparativoBureau: [
    { value: 1, text: 'Conforme' },
    { value: 2, text: 'Não conforme' }
  ],
  TipoBureau: [
    { value: 1, text: 'Cadastro restritivo' },
    { value: 2, text: 'Indício de fraude' },
    { value: 3, text: 'Óbito e fiscal' },
    { value: 4, text: 'Mídia desabonadora' },
    { value: 5, text: 'E-mail age' },
    { value: 6, text: 'Análise restritiva' },
    { value: 7, text: 'Criminal detalhe' },
    { value: 8, text: 'Segban' },
    { value: 14, text: 'Análise cadastral detalhada' },
    { value: 15, text: 'Análise cadastral detalhada PJ' },
    { value: 16, text: 'Análise cadastral simplificada' },
    { value: 17, text: 'Análise cadastral simplificada PJ' },
    { value: 18, text: 'AntiFraude' }
  ],
  TipoInformacao: [
    { value: 1, text: 'Correntista' },
    { value: 2, text: 'Socio' },
    { value: 3, text: 'Bureau' },
    { value: 4, text: 'ControladorDaConta' },
    { value: 5, text: 'Biometria' },
    { value: 6, text: 'Credor' },
    { value: 7, text: 'Operador' }
  ],
  DescricaoValidacaoOnboardingDetalhe: [
    { value: 1, text: 'Análise pendente de validação' },
    { value: 2, text: 'Aprovado' },
    { value: 3, text: 'Análise contém restrição' },
    {
      value: 98,
      text: 'Validação não encontrada, realize a consulta do bureau novamente'
    },
    { value: 99, text: 'Ocorreu um erro inesperado na análise' }
  ],
  SituacaoExecucao: [
    { value: 1, text: 'Pendente' },
    { value: 2, text: 'Executando' },
    { value: 3, text: 'Executado' },
    { value: 4, text: 'Ignorado' },
    { value: 5, text: 'Validado' },
    { value: 99, text: 'Erro Sistema' }
  ],
  TipoPreenchimento: [
    { value: 1, text: 'Escrow' },
    { value: 2, text: 'Titular' },
    { value: 3, text: 'Parceiro' },
    { value: 4, text: 'Empresa' }
  ],
  NivelBloqueioAntifraude: [
    { value: 1, text: 'Bloqueio' },
    { value: 2, text: 'Apenas Registro' },
    { value: 3, text: 'Liberação Automática por Tempo Limite' },
    { value: 4, text: 'Liberação por Permissão Especial' },
    { value: 5, text: 'Liberação Mandatória' }
  ],
  TipoTransacaoComprovante: [
    { value: 1, text: 'Transferência' },
    { value: 2, text: 'Transferência - conta reserva' },
    { value: 3, text: 'TED' },
    { value: 4, text: 'Boleto' },
    { value: 5, text: 'Boleto - concessionária' },
    { value: 6, text: 'PIX' },
    { value: 7, text: 'Devolucão Pix' },
    { value: 8, text: 'TED - STR0025' }
  ],
  StatusListaMarcacaoFraude: [
    { value: 1, text: 'Ativo' },
    { value: 2, text: 'Cancelado' }
  ],
  NivelConfiguracaoParametrizacaoRecuperacaoValores: [
    { value: 1, text: 'Global' },
    { value: 2, text: 'Parceiro' },
    { value: 3, text: 'Conta' }
  ],
  SituacaoRecuperacaoValores: [
    { value: 1, text: 'Sem recuperação' },
    { value: 2, text: 'Recuperação solicitada' },
    { value: 3, text: 'Recuperação cancelada' }
  ],
  StatusRecuperacaoValores: [
    { value: 0, text: 'Criada' },
    { value: 1, text: 'Rastreando' },
    { value: 2, text: 'Analisando' },
    { value: 3, text: 'Analisadas' },
    { value: 4, text: 'Reembolsando' },
    { value: 5, text: 'Finalizada' },
    { value: 6, text: 'Cancelada' }
  ],
  AcaoCessao: [
    { value: 0, text: 'Todas' },
    { value: 1, text: 'Enviado' },
    { value: 2, text: 'Recebido' }
  ],
  FinalidadeCessao: [
    { value: 0, text: 'Todas' },
    { value: 1, text: 'Desconto' },
    { value: 2, text: 'Caução' }
  ],
  SituacaoRecuperacaoValoresInterna: [
    { value: 0, text: 'Pendente' },
    { value: 1, text: 'Registrando' },
    { value: 2, text: 'Registrado' },
    { value: 3, text: 'Cancelado' },
    { value: 4, text: 'Confirmado' },
    { value: 5, text: 'Pendente de aprovação' },
    { value: 6, text: 'Recusado' },
    { value: 7, text: 'Expirado' },
    { value: 8, text: 'Cancelamento pendente de processamento' },
    { value: 50, text: 'Pendente de reprocessamento' },
    { value: 60, text: 'Processando' },
    { value: 97, text: 'Não processada' },
    { value: 98, text: 'Erro negócio' },
    { value: 99, text: 'Erro Sistema' }
  ],
  PrazoDeLiquidacao: [
    { value: 0, text: 'Não Utiliza' },
    { value: 1, text: 'Crédito em D+1' },
    { value: 2, text: 'Crédito em D+2' },
    { value: 3, text: 'Crédito em D+3' }
  ],
  SituacaoReporteRC06: [
    { value: 0, text: 'Pendente' },
    { value: 1, text: 'Reportado' }
  ],
  SituacaoPrazoRC06: [
    { value: 0, text: 'Reportado no prazo' },
    { value: 1, text: 'Reportado fora do prazo' },
    { value: 2, text: 'Pendente no prazo' },
    { value: 3, text: 'Pendente vencido' }
  ],
  PeriodoRC06: [
    { value: 'mesAtual', text: 'Mês atual' },
    { value: 'ultimos3Meses', text: 'Últimos 3 meses' },
    { value: 'ultimos6Meses', text: 'Últimos 6 meses' },
    { value: 'ultimoAno', text: 'Último ano' }
  ],
  CanalOcorrenciaDataRudder: [
    { value: 3, text: 'Autoatendimento' },
    { value: 6, text: 'Interbancário' },
    { value: 1, text: 'Internet' },
    { value: 5, text: 'Mídias Sociais' },
    { value: 2, text: 'Celular' },
    { value: 7, text: 'Outros' },
    { value: 4, text: 'Rede Parceiros' },
    { value: 'NENHUM', text: 'Nenhum' }
  ],
  AtividadeRelacionadaOcorrenciaDataRudder: [
    { value: 1, text: 'Abertura de conta de depósitos ou conta de pagamento' },
    { value: 2, text: 'Manutenção de conta de depósitos ou conta de pagamento' },
    { value: 3, text: 'Contratação de operação de crédito' },
    { value: 4, text: 'Transferências entre contas na própria instituição' },
    { value: 5, text: 'Transferência Eletrônica Disponível (TED)' },
    { value: 6, text: 'Transações de pagamento com emprego de cheque' },
    { value: 7, text: 'Transações de pagamento instantâneo (Pix)' },
    { value: 8, text: 'Transferências por meio de Documento de Crédito (DOC)' },
    { value: 9, text: 'Boletos de pagamento' },
    { value: 10, text: 'Saques de recursos em espécie' }
  ],
  ModalidadeFraudeOcorrenciaDataRudder: [
    { value: 1, text: 'Auto fraude' },
    { value: 2, text: 'Conta laranja' },
    { value: 3, text: 'Roubo de identidade' },
    { value: 4, text: 'Identidade sintética' },
    { value: 5, text: 'Invasão de contas' },
    { value: 6, text: 'Fraude amigável' },
    { value: 7, text: 'Fraude de comprador' },
    { value: 8, text: 'Fraude de vendedor' },
    { value: 9, text: 'Sim swap' },
    { value: 10, text: 'Fraude com boletos adulterados' },
    { value: 11, text: 'Fraude de benefícios' },
    { value: 12, text: 'Sequestro ou extorsão' },
    { value: 98, text: 'Inconclusivo' },
    { value: 99, text: 'Modalidade não relacionada' }
  ],
    SituacaoACCS004Conciliacao: [
    { value: 0, text: 'Pendent Upload' },
    { value: 1, text: 'Pendente Processamento' },
    { value: 2, text: 'Em Processamento' },
    { value: 3, text: 'Processado' },
    { value: 4, text: 'Erro Upload' },
    { value: 5, text: 'Expirado' },
    { value: 6, text: 'Cancelado' },
    { value: 7, text: 'Erro Processamento' },
  ],
}
